// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { useParams, useNavigate, useLocation } from 'react-router-dom';
// import { FaFilter, FaFileExport, FaEye, FaArrowLeft, FaInfoCircle, FaSync } from 'react-icons/fa';
// import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
// import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
// import { DatePicker } from "@mui/x-date-pickers/DatePicker";
// import dayjs from "dayjs";
// import { getAdjustedStartDate, getAdjustedEndDate } from '../../utils/dateHelper';
// import Swal from 'sweetalert2';
// import ReactPaginate from 'react-paginate';
// import ExpenseModal from '../project/expense/ExpenseModal';
// import withPermission from '../../utils/withPermission';
// import { Dropdown } from 'react-bootstrap';

// const ExpenseReport = () => {
//     const { id } = useParams(); // Project ID (optional)
//     const navigate = useNavigate();
//     const location = useLocation();
//     const [loading, setLoading] = useState(false);
//     const [expenses, setExpenses] = useState([]);
//     const [summary, setSummary] = useState({
//         totalAmount: 0,
//         totalVAT: 0,
//         adjustmentAmount: 0,
//         grandTotal: 0,
//         totalAmountAED: 0,
//         totalVATAED: 0,
//         adjustmentAmountAED: 0,
//         grandTotalAED: 0,
//         totalWPSCharge: 0,
//         totalWPSVAT: 0,
//         paymentMethods: {
//             cash: 0,
//             bank: 0,
//             other: 0
//         },
//         paymentMethodsAED: {
//             cash: 0,
//             bank: 0,
//             other: 0
//         }
//     });

//     const [filters, setFilters] = useState({
//         fromDate: dayjs().startOf('month').format('YYYY-MM-DD'),
//         toDate: dayjs().endOf('month').format('YYYY-MM-DD'),
//         project: id || '',
//         vendor: '',
//         client: '',
//         category: '',
//         expenseType: '',
//         user: '',
//         dateRange: 'yearly',
//         paymentStatus: 'all',
//         source: []
//     });

//     const [selectedEndYear, setSelectedEndYear] = useState(null);

//     const [filterOptions, setFilterOptions] = useState({
//         projects: [],
//         vendors: [],
//         clients: [],
//         categories: [],
//         users: []
//     });

//     const [selectedYear, setSelectedYear] = useState(null);
//     const [showExpenseModal, setShowExpenseModal] = useState(false);
//     const [selectedExpenseId, setSelectedExpenseId] = useState(null);
//     const [currentPage, setCurrentPage] = useState(0);
//     const [pageCount, setPageCount] = useState(0);
//     const itemsPerPage = 20;

//     const fetchFilterOptions = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             const response = await axios.get(`${backendUrl}/api/expense-report/filter-options`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             setFilterOptions(response.data);
//         } catch (error) {
//             console.error('Error fetching filter options:', error);
//         }
//     };

//     const fetchReportData = async () => {
//         setLoading(true);
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let params = new URLSearchParams();
//             params.append('fromDate', filters.fromDate);
//             params.append('toDate', filters.toDate);
//             params.append('dateRange', filters.dateRange);
//             if (filters.project) params.append('project', filters.project);
//             if (filters.vendor) params.append('vendor', filters.vendor);
//             if (filters.client) params.append('client', filters.client);
//             if (filters.category) params.append('category', filters.category);
//             if (filters.user) params.append('user', filters.user);
//             if (filters.paymentStatus !== 'all') params.append('paymentStatus', filters.paymentStatus);
//             if (filters.source && filters.source.length > 0) {
//                 params.append('source', filters.source.join(','));
//             }

//             const response = await axios.get(`${backendUrl}/api/expense-report?${params.toString()}`, {
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             if (response.data.status === 'success') {
//                 const allExpenses = response.data.data;
//                 setExpenses(allExpenses);
//                 setPageCount(Math.ceil(allExpenses.length / itemsPerPage));
                
//                 // Map summary data from backend
//                 const backendSummary = response.data.summary;
//                 setSummary({
//                     totalAmount: backendSummary.total_excluding_vat,
//                     totalVAT: backendSummary.total_vat,
//                     adjustmentAmount: backendSummary.total_adjustment,
//                     grandTotal: backendSummary.total_including_vat,
//                     totalAmountAED: backendSummary.total_excluding_vat_aed,
//                     totalVATAED: backendSummary.total_vat_aed,
//                     adjustmentAmountAED: backendSummary.total_adjustment_aed,
//                     grandTotalAED: backendSummary.total_including_vat_aed,
//                     totalWPSCharge: backendSummary.total_wps_charge || 0,
//                     totalWPSVAT: backendSummary.total_wps_vat || 0,
//                     paymentMethods: { cash: 0, bank: 0, other: 0 }, // Optional: recalculate if needed
//                     paymentMethodsAED: { cash: 0, bank: 0, other: 0 }
//                 });

//                 // Audit capture for parity checks
//                 const debugData = allExpenses.map(e => ({
//                     id: e.expense_id,
//                     date: e.date,
//                     narration: (e.narration || "No Narration").trim().toLowerCase(),
//                     amount: Number(e.total),
//                     journal_id: e.journal_id
//                 }));
//                 localStorage.setItem('debugExpenseReport', JSON.stringify(debugData));
//                 console.log(`📊 [ExpenseReport] ${debugData.length} items captured for audit.`);
//             }
//         } catch (error) {
//             console.error('Error fetching report data:', error);
//             Swal.fire('Error', 'Failed to fetch report data', 'error');
//         } finally {
//             setLoading(false);
//         }
//     };

//     useEffect(() => {
//         fetchFilterOptions();
//         // Set initial filters from URL if project ID is provided
//         if (id) {
//             setFilters(prev => ({ ...prev, project: id, dateRange: 'this_year' }));
//         }
//     }, [id]);

//     useEffect(() => {
//         fetchReportData();
//     }, [filters]);

//     const handleFilterChange = (e) => {
//         const { name, value } = e.target;
//         setFilters(prev => {
//             const newFilters = { ...prev, [name]: value };
            
//             if (name === 'dateRange') {
//                 setSelectedYear(null);
//                 setSelectedEndYear(null);
//                 if (value === 'yearly') {
//                     newFilters.fromDate = '';
//                     newFilters.toDate = '';
//                 }
//             }
//             return newFilters;
//         });
//     };

//     const handleYearChange = (newValue) => {
//         setSelectedYear(newValue);
//         if (newValue) {
//             setFilters(prev => ({
//                 ...prev,
//                 fromDate: newValue.startOf('year').format('YYYY-MM-DD'),
//                 // Auto-sync End Year
//                 toDate: newValue.endOf('year').format('YYYY-MM-DD')
//             }));
//             setSelectedEndYear(newValue);
//         }
//     };

//     const handleEndYearChange = (newValue) => {
//         setSelectedEndYear(newValue);
//         if (newValue) {
//             setFilters(prev => ({
//                 ...prev,
//                 toDate: newValue.endOf('year').format('YYYY-MM-DD')
//             }));
//         }
//     };

//     const handleSourceFilterChange = (source) => {
//         setFilters(prev => {
//             const newSource = prev.source.includes(source)
//                 ? prev.source.filter(s => s !== source)
//                 : [...prev.source, source];
//             return { ...prev, source: newSource };
//         });
//     };

//     const handlePageClick = (data) => {
//         setCurrentPage(data.selected);
//     };

//     const handleExport = async () => {
//         try {
//             const backendUrl = process.env.REACT_APP_BACKEND_URL;
//             const userInfo = JSON.parse(localStorage.getItem('user-info'));
//             const origin = localStorage.getItem('user-origin');
//             const token = userInfo?.token;

//             let params = new URLSearchParams();
//             params.append('fromDate', filters.fromDate);
//             params.append('toDate', filters.toDate);
//             params.append('dateRange', filters.dateRange);
//             if (filters.project) params.append('project', filters.project);
//             if (filters.vendor) params.append('vendor', filters.vendor);
//             if (filters.client) params.append('client', filters.client);
//             if (filters.category) params.append('category', filters.category);
//             if (filters.user) params.append('user', filters.user);
//             if (filters.paymentStatus !== 'all') params.append('paymentStatus', filters.paymentStatus);
//             if (filters.source && filters.source.length > 0) {
//                 params.append('source', filters.source.join(','));
//             }

//             const response = await axios({
//                 url: `${backendUrl}/api/expense-report/export?${params.toString()}`,
//                 method: 'GET',
//                 responseType: 'blob',
//                 headers: {
//                     'Authorization': `Bearer ${token}`,
//                     'Tenant-Origin': origin,
//                 },
//             });

//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', `Expense_Report_${filters.fromDate}_to_${filters.toDate}.xlsx`);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//         } catch (error) {
//             console.error('Export error:', error);
//             Swal.fire('Error', 'Failed to export report', 'error');
//         }
//     };

//     const formatCurrency = (amount) => {
//         return new Intl.NumberFormat('en-US', {
//             minimumFractionDigits: 2,
//             maximumFractionDigits: 2
//         }).format(amount || 0);
//     };

//     const displayExpenses = expenses.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

//     return (
//         <div className="container-fluid py-4">
//             <div className="d-flex justify-content-between align-items-center mb-4">
//                 <div className="d-flex align-items-center">
//                     <button className="btn btn-link p-0 me-3" onClick={() => navigate(-1)}>
//                         <FaArrowLeft />
//                     </button>
//                     <h4 className="mb-0">Expense Report</h4>
//                 </div>
//                 <div className="d-flex gap-2">
//                     <button className="btn btn-primary d-flex align-items-center gap-2" onClick={handleExport}>
//                         <FaFileExport /> Export Excel
//                     </button>
//                     <button className="btn btn-outline-secondary" onClick={fetchReportData}>
//                         <FaSync className={loading ? 'fa-spin' : ''} />
//                     </button>
//                 </div>
//             </div>

//             {/* Filter Section */}
//             <div className="card mb-4 border-0 shadow-sm">
//                 <div className="card-body">
//                     <div className="row g-3">
//                         <div className="col-md-2">
//                             <label className="form-label fw-bold small text-muted">Date Range</label>
//                             <select 
//                                 className="form-select form-select-sm" 
//                                 name="dateRange" 
//                                 value={filters.dateRange} 
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="yearly">Yearly</option>
//                                 <option value="custom">Custom Range</option>
//                             </select>
//                         </div>

//                         {filters.dateRange === 'yearly' && (
//                             <>
//                                  <div className="col-md-2">
//                                      <label className="form-label fw-bold small text-muted">Start Date</label>
//                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                          <DatePicker
//                                              views={["year", "month", "day"]}
//                                              openTo="year"
//                                              format="DD-MM-YYYY"
//                                              value={filters.fromDate ? dayjs(filters.fromDate) : null}
//                                              onChange={(newValue) => {
//                                                  if (newValue) {
//                                                      setSelectedYear(newValue);
//                                                      if (!filters.fromDate || dayjs(filters.fromDate).year() !== newValue.year()) {
//                                                          const start = newValue.startOf('year');
//                                                          const end = newValue.endOf('year');
//                                                          setFilters(prev => ({
//                                                              ...prev,
//                                                              fromDate: start.format('YYYY-MM-DD'),
//                                                              toDate: end.format('YYYY-MM-DD')
//                                                          }));
//                                                          setSelectedEndYear(newValue);
//                                                      } else {
//                                                          const { startDate: newStart, suggestedEndDate } = getAdjustedStartDate(newValue, filters.toDate);
//                                                          setFilters(prev => ({
//                                                              ...prev,
//                                                              fromDate: newStart,
//                                                              ...(suggestedEndDate && { toDate: suggestedEndDate })
//                                                          }));
//                                                      }
//                                                  }
//                                              }}
//                                              slotProps={{ textField: { size: 'small', fullWidth: true } }}
//                                          />
//                                      </LocalizationProvider>
//                                  </div>
//                                  <div className="col-md-2">
//                                      <label className="form-label fw-bold small text-muted">End Date</label>
//                                      <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                          <DatePicker
//                                              views={["year", "month", "day"]}
//                                              openTo="year"
//                                              format="DD-MM-YYYY"
//                                              value={filters.toDate ? dayjs(filters.toDate) : null}
//                                              onChange={(newValue) => {
//                                                  if (newValue) {
//                                                      setSelectedEndYear(newValue);
//                                                      if (!filters.toDate || dayjs(filters.toDate).year() !== newValue.year()) {
//                                                          setFilters(prev => ({ ...prev, toDate: newValue.endOf('year').format('YYYY-MM-DD') }));
//                                                      } else {
//                                                          setFilters(prev => ({ ...prev, toDate: getAdjustedEndDate(newValue, filters.fromDate) }));
//                                                      }
//                                                  }
//                                              }}
//                                              slotProps={{ textField: { size: 'small', fullWidth: true } }}
//                                          />
//                                      </LocalizationProvider>
//                                  </div>
//                             </>
//                         )}

//                         {filters.dateRange === 'custom' && (
//                             <>
//                                 <div className="col-md-2">
//                                     <label className="form-label fw-bold small text-muted">From Date</label>
//                                     <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                         <DatePicker
//                                             views={["year", "month", "day"]}
//                                             format="DD-MM-YYYY"
//                                             value={filters.fromDate ? dayjs(filters.fromDate) : null}
//                                             onChange={(newValue) => {
//                                                  const { startDate: newStart, suggestedEndDate } = getAdjustedStartDate(newValue, filters.toDate);
//                                                  setFilters(prev => ({
//                                                      ...prev,
//                                                      fromDate: newStart,
//                                                      ...(suggestedEndDate && { toDate: suggestedEndDate })
//                                                  }));
//                                              }}
//                                             slotProps={{ textField: { size: 'small', fullWidth: true } }}
//                                         />
//                                     </LocalizationProvider>
//                                 </div>
//                                 <div className="col-md-2">
//                                     <label className="form-label fw-bold small text-muted">To Date</label>
//                                     <LocalizationProvider dateAdapter={AdapterDayjs}>
//                                         <DatePicker
//                                             views={["year", "month", "day"]}
//                                             format="DD-MM-YYYY"
//                                             value={filters.toDate ? dayjs(filters.toDate) : null}
//                                             onChange={(newValue) => {
//                                                  setFilters(prev => ({ ...prev, toDate: getAdjustedEndDate(newValue, filters.fromDate) }));
//                                              }}
//                                             slotProps={{ textField: { size: 'small', fullWidth: true } }}
//                                         />
//                                     </LocalizationProvider>
//                                 </div>
//                             </>
//                         )}

//                         <div className="col-md-3">
//                             <label className="form-label fw-bold small text-muted">Project</label>
//                             <select 
//                                 className="form-select form-select-sm" 
//                                 name="project" 
//                                 value={filters.project} 
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">All Projects</option>
//                                 {filterOptions.projects.map(p => (
//                                     <option key={p.id} value={p.id}>{p.name}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="col-md-2">
//                             <label className="form-label fw-bold small text-muted">Vendor</label>
//                             <select 
//                                 className="form-select form-select-sm" 
//                                 name="vendor" 
//                                 value={filters.vendor} 
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">All Vendors</option>
//                                 {filterOptions.vendors.map(v => (
//                                     <option key={v.id} value={v.id}>{v.name}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="col-md-2">
//                             <label className="form-label fw-bold small text-muted">Category</label>
//                             <select 
//                                 className="form-select form-select-sm" 
//                                 name="category" 
//                                 value={filters.category} 
//                                 onChange={handleFilterChange}
//                             >
//                                 <option value="">All Categories</option>
//                                 {filterOptions.categories.map(c => (
//                                     <option key={c.id} value={c.id}>{c.name}</option>
//                                 ))}
//                             </select>
//                         </div>

//                         <div className="col-md-2">
//                             <label className="form-label fw-bold small text-muted">Source</label>
//                             <Dropdown autoClose="outside">
//                                 <Dropdown.Toggle variant="outline-secondary" size="sm" className="w-100 d-flex justify-content-between align-items-center">
//                                     {filters.source.length === 0 ? 'All Sources' : `${filters.source.length} Selected`}
//                                 </Dropdown.Toggle>
//                                 <Dropdown.Menu className="w-100 p-2">
//                                     <div className="form-check">
//                                         <input className="form-check-input" type="checkbox" id="sourceDirect" checked={filters.source.includes('direct')} onChange={() => handleSourceFilterChange('direct')} />
//                                         <label className="form-check-label" htmlFor="sourceDirect">Direct Expense</label>
//                                     </div>
//                                     <div className="form-check">
//                                         <input className="form-check-input" type="checkbox" id="sourcePetty" checked={filters.source.includes('pettycash')} onChange={() => handleSourceFilterChange('pettycash')} />
//                                         <label className="form-check-label" htmlFor="sourcePetty">Petty Cash</label>
//                                     </div>
//                                     <div className="form-check">
//                                         <input className="form-check-input" type="checkbox" id="sourceSalary" checked={filters.source.includes('salary')} onChange={() => handleSourceFilterChange('salary')} />
//                                         <label className="form-check-label" htmlFor="sourceSalary">Employee Salary</label>
//                                     </div>
//                                 </Dropdown.Menu>
//                             </Dropdown>
//                         </div>
//                     </div>

//                     {/* Active Filters Display */}
//                     {(filters.fromDate || filters.toDate || filters.project || filters.vendor || filters.category || (filters.source && filters.source.length > 0)) && (
//                         <div className="mt-3">
//                             <small className="text-muted d-block mb-1 font-size-11">Active Filters:</small>
//                             <div className="d-flex flex-wrap gap-1">
//                                 {filters.fromDate && filters.toDate && 
//                                  dayjs(filters.fromDate).isSame(dayjs(filters.toDate).startOf('year'), 'day') && 
//                                  dayjs(filters.toDate).isSame(dayjs(filters.fromDate).endOf('year'), 'day') ? (
//                                     <span className="badge bg-info text-white">
//                                         Period: {dayjs(filters.fromDate).format('MMM YYYY')} – {dayjs(filters.toDate).format('MMM YYYY')}
//                                     </span>
//                                 ) : (
//                                     <>
//                                         {filters.fromDate && (
//                                             <span className="badge bg-info text-white">
//                                                 From: {dayjs(filters.fromDate).format('DD-MM-YYYY')}
//                                             </span>
//                                         )}
//                                         {filters.toDate && (
//                                             <span className="badge bg-info text-white">
//                                                 To: {dayjs(filters.toDate).format('DD-MM-YYYY')}
//                                             </span>
//                                         )}
//                                     </>
//                                 )}
//                                 {filters.project && (
//                                     <span className="badge bg-warning text-dark">
//                                         Project: {filterOptions.projects.find(p => p.id == filters.project)?.name}
//                                     </span>
//                                 )}
//                                 {filters.vendor && (
//                                     <span className="badge bg-success text-white">
//                                         Vendor: {filterOptions.vendors.find(v => v.id == filters.vendor)?.name}
//                                     </span>
//                                 )}
//                                 {filters.category && (
//                                     <span className="badge bg-primary text-white">
//                                         Category: {filterOptions.categories.find(c => c.id == filters.category)?.name}
//                                     </span>
//                                 )}
//                                 {filters.source && filters.source.length > 0 && (
//                                     <span className="badge bg-secondary text-white">
//                                         Source: {filters.source.join(', ')}
//                                     </span>
//                                 )}
//                             </div>
//                         </div>
//                     )}
//                 </div>
//             </div>

//             {/* Summary Cards */}
//             <div className="row mb-4">
//                 <div className="col-md-3">
//                     <div className="card border-0 shadow-sm bg-primary text-white">
//                         <div className="card-body">
//                             <h6 className="card-subtitle mb-2 opacity-75">Total Base Amount</h6>
//                             <h3 className="card-title mb-0">{formatCurrency(summary.totalAmount)}</h3>
//                             <div className="mt-2 small">AED {formatCurrency(summary.totalAmountAED)}</div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-md-3">
//                     <div className="card border-0 shadow-sm bg-info text-white">
//                         <div className="card-body">
//                             <h6 className="card-subtitle mb-2 opacity-75">Total VAT</h6>
//                             <h3 className="card-title mb-0">{formatCurrency(summary.totalVAT)}</h3>
//                             <div className="mt-2 small">AED {formatCurrency(summary.totalVATAED)}</div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-md-3">
//                     <div className="card border-0 shadow-sm bg-warning text-white">
//                         <div className="card-body">
//                             <h6 className="card-subtitle mb-2 opacity-75">Total Adjustment</h6>
//                             <h3 className="card-title mb-0">{formatCurrency(summary.adjustmentAmount)}</h3>
//                             <div className="mt-2 small">AED {formatCurrency(summary.adjustmentAmountAED)}</div>
//                         </div>
//                     </div>
//                 </div>
//                 <div className="col-md-3">
//                     <div className="card border-0 shadow-sm bg-success text-white">
//                         <div className="card-body">
//                             <h6 className="card-subtitle mb-2 opacity-75">Grand Total</h6>
//                             <h3 className="card-title mb-0">{formatCurrency(summary.grandTotal)}</h3>
//                             <div className="mt-2 small font-weight-bold">AED {formatCurrency(summary.grandTotalAED)}</div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/* Report Table */}
//             <div className="card border-0 shadow-sm">
//                 <div className="card-body p-0">
//                     <div className="table-responsive">
//                         <table className="table table-hover align-middle mb-0">
//                             <thead className="bg-light">
//                                 <tr>
//                                     <th className="ps-4">Date</th>
//                                     <th>Narration</th>
//                                     <th>Project</th>
//                                     <th>Vendor</th>
//                                     <th>Category</th>
//                                     <th className="text-end">Base Amount</th>
//                                     <th className="text-end">VAT</th>
//                                     <th className="text-end">Adjustment</th>
//                                     <th className="text-end pe-4">Total (AED)</th>
//                                     <th>Status</th>
//                                     <th>Action</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {loading ? (
//                                     <tr>
//                                         <td colSpan="11" className="text-center py-5">
//                                             <div className="spinner-border text-primary" role="status">
//                                                 <span className="visually-hidden">Loading...</span>
//                                             </div>
//                                         </td>
//                                     </tr>
//                                 ) : displayExpenses.length === 0 ? (
//                                     <tr>
//                                         <td colSpan="11" className="text-center py-5 text-muted">No expenses found for the selected period.</td>
//                                     </tr>
//                                 ) : (
//                                     displayExpenses.map((expense, index) => (
//                                         <tr key={index}>
//                                             <td className="ps-4 text-nowrap">{dayjs(expense.date).format('DD-MMM-YYYY')}</td>
//                                             <td>
//                                                 <div className="text-truncate" style={{ maxWidth: '200px' }} title={expense.narration}>
//                                                     {expense.narration}
//                                                 </div>
//                                                 {expense.invoice_no && <small className="text-muted d-block">Inv: {expense.invoice_no}</small>}
//                                             </td>
//                                             <td>{expense.project || <span className="text-muted">N/A</span>}</td>
//                                             <td>{expense.vendor || <span className="text-muted">N/A</span>}</td>
//                                             <td><span className="badge bg-light text-dark fw-normal">{expense.category}</span></td>
//                                             <td className="text-end">
//                                                 {formatCurrency(expense.amount_excl_vat)}
//                                                 <div className="small text-muted">{expense.vendor_currency}</div>
//                                             </td>
//                                             <td className="text-end">{formatCurrency(expense.vat_amount)}</td>
//                                             <td className="text-end">{formatCurrency(expense.adjustment_amount)}</td>
//                                             <td className="text-end pe-4 fw-bold">{formatCurrency(expense.total_aed)}</td>
//                                             <td>
//                                                 <span className={`badge rounded-pill ${
//                                                     expense.payment_status === 'Paid' ? 'bg-success-subtle text-success' :
//                                                     expense.payment_status === 'Partial' ? 'bg-warning-subtle text-warning' :
//                                                     'bg-danger-subtle text-danger'
//                                                 }`}>
//                                                     {expense.payment_status}
//                                                 </span>
//                                             </td>
//                                             <td>
//                                                 <button className="btn btn-sm btn-light" onClick={() => {
//                                                     setSelectedExpenseId(expense.expense_id);
//                                                     setShowExpenseModal(true);
//                                                 }}>
//                                                     <FaEye />
//                                                 </button>
//                                             </td>
//                                         </tr>
//                                     ))
//                                 )}
//                             </tbody>
//                         </table>
//                     </div>
//                 </div>
//                 {pageCount > 1 && (
//                     <div className="card-footer bg-white border-0 py-3">
//                         <ReactPaginate
//                             previousLabel={'Previous'}
//                             nextLabel={'Next'}
//                             breakLabel={'...'}
//                             pageCount={pageCount}
//                             marginPagesDisplayed={2}
//                             pageRangeDisplayed={5}
//                             onPageChange={handlePageClick}
//                             containerClassName={'pagination pagination-sm justify-content-center mb-0'}
//                             pageClassName={'page-item'}
//                             pageLinkClassName={'page-link'}
//                             previousClassName={'page-item'}
//                             previousLinkClassName={'page-link'}
//                             nextClassName={'page-item'}
//                             nextLinkClassName={'page-link'}
//                             breakClassName={'page-item'}
//                             breakLinkClassName={'page-link'}
//                             activeClassName={'active'}
//                         />
//                     </div>
//                 )}
//             </div>

//             {showExpenseModal && (
//                 <ExpenseModal
//                     show={showExpenseModal}
//                     handleClose={() => setShowExpenseModal(false)}
//                     expenseId={selectedExpenseId}
//                     mode="view"
//                 />
//             )}
//         </div>
//     );
// };

// export default ExpenseReport;

import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import moment from 'moment';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import TextField from "@mui/material/TextField";
import dayjs from "dayjs";
import Select from "react-select";
import ReactPaginate from 'react-paginate';
import { FaFilter, FaSearch, FaTimes } from 'react-icons/fa';


const ExpenseReport = () => {
    const [expenses, setExpenses] = useState([]);
    const [loading, setLoading] = useState(true);
    const [selectedExpenseTypes, setSelectedExpenseTypes] = useState([]);
    const [topSelectedExpenseTypes, setTopSelectedExpenseTypes] = useState([]);
    const [availableExpenseTypes, setAvailableExpenseTypes] = useState([]);
    const [showExpenseTypeDropdown, setShowExpenseTypeDropdown] = useState(false);
    const [expenseTypeSearch, setExpenseTypeSearch] = useState('');
    const expenseTypeFilterRef = useRef(null);
    const [filters, setFilters] = useState({
        dateRange: 'this_month', // Match AllExpenseList default
        fromDate: '',
        toDate: '',
        project: '',
        vendor: '',
        client: '',
        category: '',
        expenseType: '',
        user: '',
        paymentStatus: '',
        taxType: '',
        source: []
    });
    const [expenseTypes, setExpenseTypes] = useState([]);
    const [filterOptions, setFilterOptions] = useState({
        projects: [],
        vendors: [],
        clients: [],
        categories: [],
        expense_types: [],
        users: []
    });
    const [summary, setSummary] = useState({
        totalAmount: 0,
        totalVAT: 0,
        grandTotal: 0,
        adjustmentAmount: 0,
        totalAmountAED: 0,
        totalVATAED: 0,
        grandTotalAED: 0,
        adjustmentAmountAED: 0,
        paymentMethods: {
            cash: 0,
            bank: 0,
            other: 0
        },
        paymentMethodsAED: {
            cash: 0,
            bank: 0,
            other: 0
        },
        totalWpsCharge: 0,
        totalWpsVat: 0,
        totalWpsChargeAED: 0,
        totalWpsVatAED: 0
    });
    const [selectedExpense, setSelectedExpense] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [journalDetails, setJournalDetails] = useState(null);
    const [journalLoading, setJournalLoading] = useState(false);
    const [applyFilterClicked, setApplyFilterClicked] = useState(false);
    const [currentPage, setCurrentPage] = useState(0);
    const [pageCount, setPageCount] = useState(0);
    const [filteredData, setFilteredData] = useState([]);
    const itemsPerPage = 20;

    const [bankAccounts, setBankAccounts] = useState([]);
    const [companySettings, setCompanySettings] = useState(null);

    const backendUrl = process.env.REACT_APP_BACKEND_URL;
    const webzashUrl = process.env.REACT_APP_WEBZASH_URL;
    const userInfo = JSON.parse(localStorage.getItem("user-info"));
    const token = userInfo?.token;
    const origin = localStorage.getItem("user-origin");
    const apiKey = process.env.REACT_APP_API_KEY;

    useEffect(() => {
        fetchFilterOptions();
        fetchExpenseTypes();
        fetchBankAccounts();
        fetchCompanySettings();
    }, [filters]);

    const fetchBankAccounts = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/bank-accounts`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });
            setBankAccounts(response.data.account || []);
        } catch (error) {
            console.error("Error fetching bank accounts:", error);
        }
    };

    const fetchCompanySettings = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/settings`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });
            if (response.data?.setting) {
                setCompanySettings(response.data.setting);
            }
        } catch (error) {
            console.error("Error fetching company settings:", error);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (expenseTypeFilterRef.current && !expenseTypeFilterRef.current.contains(event.target)) {
                setShowExpenseTypeDropdown(false);
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, []);

    const isTypeSelected = (typeId) => {
        const strId = String(typeId);
        return selectedExpenseTypes.includes(strId) ||
               selectedExpenseTypes.some(s => s.toLowerCase() === strId.toLowerCase());
    };

    const handleToggleExpenseType = (typeId) => {
        const strId = String(typeId);
        setSelectedExpenseTypes(prev => {
            const isCurrentlySelected = prev.includes(strId) || prev.some(s => s.toLowerCase() === strId.toLowerCase());
            if (isCurrentlySelected) {
                return prev.filter(id => id !== strId && id.toLowerCase() !== strId.toLowerCase());
            } else {
                return [...prev, strId];
            }
        });
    };

    const handleSelectAllVisibleExpenseTypes = (visibleTypes) => {
        const visibleIds = visibleTypes.map(t => String(t.id));
        const allVisibleSelected = visibleIds.length > 0 && visibleIds.every(id => isTypeSelected(id));

        if (allVisibleSelected) {
            setSelectedExpenseTypes(prev => 
                prev.filter(id => !visibleIds.includes(id) && !visibleIds.some(v => v.toLowerCase() === id.toLowerCase()))
            );
        } else {
            setSelectedExpenseTypes(prev => 
                Array.from(new Set([...prev, ...visibleIds]))
            );
        }
    };

    const applyExpenseTypeFilter = (typesToApply = selectedExpenseTypes) => {
        setShowExpenseTypeDropdown(false);
        let typeFilterString = typesToApply.join(',');
        if (typesToApply.length === 0) {
            typeFilterString = '__none__';
        } else {
            const allSelected = availableExpenseTypes.length > 0 && 
                availableExpenseTypes.every(t => typesToApply.includes(String(t.id)) || typesToApply.some(s => s.toLowerCase() === String(t.id).toLowerCase()));
            if (allSelected && topSelectedExpenseTypes.length === 0) {
                typeFilterString = '';
            }
        }
        setCurrentPage(0);
        fetchData(0, { ...filters, expenseType: typeFilterString }, typesToApply, true);
    };

    const clearExpenseTypeFilter = () => {
        setShowExpenseTypeDropdown(false);
        setExpenseTypeSearch('');
        const resetTypes = topSelectedExpenseTypes.length > 0 
            ? topSelectedExpenseTypes 
            : availableExpenseTypes.map(t => String(t.id));
        setSelectedExpenseTypes(resetTypes);
        setCurrentPage(0);
        const filterString = topSelectedExpenseTypes.length > 0 ? topSelectedExpenseTypes.join(',') : '';
        fetchData(0, { ...filters, expenseType: filterString }, resetTypes, topSelectedExpenseTypes.length > 0);
    };

    const fetchData = async (pageIndex = currentPage, activeFilters = filters, activeTypes = selectedExpenseTypes, isColumnFilter = false) => {
        try {
            setLoading(true);
            const params = { ...activeFilters, page: pageIndex + 1, limit: itemsPerPage };
            if (Array.isArray(params.source) && params.source.length > 0) {
                params.source = params.source.join(',');
            } else if (!params.source || params.source.length === 0) {
                delete params.source;
            }
            if (Array.isArray(activeTypes) && activeTypes.length > 0) {
                params.expenseType = activeTypes.join(',');
            } else if (!params.expenseType) {
                delete params.expenseType;
            }
            if (params.taxType) {
                params.tax_type = params.taxType;
            }

            const response = await axios.get(`${backendUrl}/api/expense-report`, {
                params: params,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });

            const data = (response.data.data && response.data.data.data) ? response.data.data.data : (response.data.data || []);
            
            if (response.data.summary && response.data.summary.total_count) {
                setPageCount(Math.ceil(response.data.summary.total_count / itemsPerPage));
            } else {
                setPageCount(1);
            }

            const dataWithAED = data.map(expense => {
                const currency = (expense.vendor_currency || 'AED').toString().trim().toUpperCase();
                const rate = currency === 'AED'
                    ? 1
                    : (parseFloat(companySettings?.usd_to_aed || localStorage.getItem('exchange_rate') || expense.exchange_rate) || 3.692);
                
                const getExactAED = (val, aedVal) => {
                    if (aedVal !== null && aedVal !== undefined && Number(aedVal) > 0) return Number(aedVal);
                    const num = Number(val || 0);
                    return num > 0 ? (rate > 1 ? num * rate : num) : 0;
                };

                const amountExclVat = Number(expense.amount_excl_vat ?? expense.amount_without_tax ?? expense.amount ?? 0);
                const vatAmount = Number(expense.vat_amount || 0);
                const adjustmentAmount = Number(expense.adjustment_amount || 0);
                const totalAmount = Number(expense.total ?? expense.grand_total ?? expense.total_amount ?? (amountExclVat + vatAmount + adjustmentAmount));
                
                let paidAmount = Number(expense.paid_amount ?? expense.total_paid_amount ?? 0);
                let balanceAmount = Math.max(0, totalAmount - paidAmount);
                if (expense.payment_status === 'Paid' || (totalAmount > 0 && paidAmount >= totalAmount - 0.01)) {
                    paidAmount = totalAmount;
                    balanceAmount = 0;
                }

                const amountAED = getExactAED(amountExclVat, expense.amount_excl_vat_aed || expense.amount_aed);
                const vatAmountAED = (expense.vat_amount_aed !== null && expense.vat_amount_aed !== undefined && Number(expense.vat_amount_aed) > 0)
                    ? Number(expense.vat_amount_aed)
                    : getExactAED(vatAmount, expense.vat_amount_aed || expense.vat_aed);
                const adjustmentAmountAED = getExactAED(adjustmentAmount, expense.adjustment_amount_aed || expense.adjustment_aed);
                const totalAED = (expense.total_aed !== null && expense.total_aed !== undefined && Number(expense.total_aed) > 0)
                    ? Number(expense.total_aed)
                    : getExactAED(totalAmount, expense.total_aed || expense.grand_total_aed);
                
                const paidAmountAED = balanceAmount === 0 ? totalAED : getExactAED(paidAmount, expense.paid_amount_aed || expense.paid_aed);
                const balanceAmountAED = balanceAmount === 0 ? 0 : Math.max(0, totalAED - paidAmountAED);

                return {
                    ...expense,
                    amount_excl_vat: amountExclVat,
                    vat_amount: vatAmount,
                    adjustment_amount: adjustmentAmount,
                    total: totalAmount,
                    paid_amount: paidAmount,
                    balance_amount: balanceAmount,
                    amount_aed: amountAED,
                    vat_amount_aed: vatAmountAED,
                    adjustment_amount_aed: adjustmentAmountAED,
                    total_aed: totalAED,
                    paid_amount_aed: paidAmountAED,
                    balance_amount_aed: balanceAmountAED,
                    wps_charge_aed: getExactAED(expense.wps_charge || 0, expense.wps_charge_aed),
                    wps_vat_aed: getExactAED(expense.wps_vat || 0, expense.wps_vat_aed)
                };
            });

            // If not triggered from table column filter, recalculate availableExpenseTypes
            if (!isColumnFilter) {
                const rawActiveTypes = (Array.isArray(activeTypes) && activeTypes.length > 0)
                    ? activeTypes.map(String)
                    : (activeFilters.expenseType ? String(activeFilters.expenseType).split(',').map(s => s.trim()).filter(Boolean) : []);

                if (rawActiveTypes.length > 0) {
                    // Top filter selected specific expense types: only show those selected types in table filter
                    const matched = [];
                    const seen = new Set();
                    rawActiveTypes.forEach(tId => {
                        const master = expenseTypes.find(t => String(t.id) === String(tId) || (t.name && t.name.toLowerCase() === String(tId).toLowerCase()));
                        const id = master ? String(master.id) : String(tId);
                        const name = master ? master.name : String(tId);
                        if (!seen.has(id)) {
                            seen.add(id);
                            matched.push({ id, name });
                        }
                    });
                    matched.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
                    setAvailableExpenseTypes(matched);
                    setSelectedExpenseTypes(matched.map(t => String(t.id)));
                } else {
                    // Top filter is empty / All Expense Types:
                    // Use backend provided available_expense_types across all pages of the dataset!
                    const backendTypes = response.data?.available_expense_types || response.data?.summary?.available_expense_types;
                    if (Array.isArray(backendTypes) && backendTypes.length > 0) {
                        const sortedBackend = [...backendTypes].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
                        setAvailableExpenseTypes(sortedBackend);
                        setSelectedExpenseTypes(sortedBackend.map(t => String(t.id)));
                    } else {
                        // Fallback extraction from loaded page items
                        const extracted = [];
                        const seen = new Set();
                        (dataWithAED || []).forEach(e => {
                            const name = e.expenseType?.name || e.expense_type?.name || e.expense_type_name || (typeof e.type === 'string' ? e.type : '') || '';
                            if (!name || name === '-' || name.trim() === '') return;

                            const master = expenseTypes.find(t => 
                                (t.name && t.name.toLowerCase() === name.toLowerCase()) ||
                                String(t.id) === String(e.expense_type_id || e.expenseType?.id || e.expense_type?.id)
                            );
                            const id = master ? String(master.id) : (e.expense_type_id ? String(e.expense_type_id) : name);
                            const label = master ? master.name : name;

                            if (!seen.has(id)) {
                                seen.add(id);
                                extracted.push({ id, name: label });
                            }
                        });
                        extracted.sort((a, b) => (a.name || "").localeCompare(b.name || ""));
                        setAvailableExpenseTypes(extracted);
                        setSelectedExpenseTypes(extracted.map(t => String(t.id)));
                    }
                }
            }

            // Filter out reversed transactions and apply client-side expenseType filtering if needed
            const currentSelectedTypes = (Array.isArray(activeTypes) && activeTypes.length > 0)
                ? activeTypes.map(String)
                : (activeFilters.expenseType ? String(activeFilters.expenseType).split(',').map(s => s.trim()).filter(Boolean) : []);

            const filteredDataResult = dataWithAED.filter(e => {
                const notReversed = e.reconciliation_status !== 'reversed' && e.expense_reconciliation_status !== 'reversed';
                if (!notReversed) return false;
                if (currentSelectedTypes.length > 0) {
                    const matchId = currentSelectedTypes.includes(String(e.expense_type_id || ''));
                    const matchObjId = e.expense_type?.id && currentSelectedTypes.includes(String(e.expense_type.id));
                    const matchObjId2 = e.expenseType?.id && currentSelectedTypes.includes(String(e.expenseType.id));
                    const matchName = (e.expense_type?.name && currentSelectedTypes.some(t => t.toLowerCase() === e.expense_type.name.toLowerCase())) ||
                                      (e.expenseType?.name && currentSelectedTypes.some(t => t.toLowerCase() === e.expenseType.name.toLowerCase()));
                    const matchType = currentSelectedTypes.includes(String(e.type || ''));
                    return matchId || matchObjId || matchObjId2 || matchName || matchType;
                }
                return true;
            });

            setExpenses(filteredDataResult);
            setFilteredData(filteredDataResult);

            if (response.data.summary) {
                const s = response.data.summary;
                setSummary({
                    totalAmount: s.total_amount ?? s.total_excluding_vat ?? 0,
                    totalVAT: s.total_vat ?? 0,
                    adjustmentAmount: s.total_adjustment ?? 0,
                    grandTotal: s.grand_total ?? s.total_including_vat ?? 0,
                    totalAmountAED: s.total_amount_aed ?? s.total_excluding_vat_aed ?? 0,
                    totalVATAED: s.total_vat_aed ?? 0,
                    adjustmentAmountAED: s.total_adjustment_aed ?? 0,
                    grandTotalAED: s.grand_total_aed ?? s.total_including_vat_aed ?? 0,
                    totalWpsCharge: s.total_wps_charge || 0,
                    totalWpsVat: s.total_wps_vat || 0,
                    totalWpsChargeAED: s.total_wps_charge_aed || 0,
                    totalWpsVatAED: s.total_wps_vat_aed || 0,
                    totalPaidAED: s.total_paid_aed || 0,
                    totalBalanceAED: s.total_balance_aed || 0,
                    paymentMethods: {
                        cash: s.total_paid_cash || 0,
                        bank: s.total_paid_bank || 0,
                        other: s.total_balance || 0
                    },
                    paymentMethodsAED: {
                        cash: s.total_paid_cash_aed || 0,
                        bank: s.total_paid_bank_aed || 0,
                        other: s.total_balance_aed || 0
                    },
                    total_count: s.total_count || 0
                });
            } else {
                calculateSummary(filteredDataResult);
            }

            // Diagnostic logging for debugging discrepancies
            const debugData = filteredDataResult.map(e => {
                const narration = (e.narration || e.description || "No Narration").trim().toLowerCase();
                const amount = Number(e.total_aed || e.total || 0);
                const vat = Number(e.vat_amount_aed || e.vat_amount || 0);
                const date = (e.date || "").substring(0, 10);
                
                return { 
                    id: e.expense_id || e.id, 
                    narration, 
                    amount, 
                    vat,
                    date,
                    payment_status: e.payment_status,
                    journal_id: e.journal_id
                };
            });
            localStorage.setItem('debugExpenseReport', JSON.stringify(debugData));
            console.log(`%c📊 [ExpenseReport] Data mapped for audit. Loaded ${filteredDataResult.length} items.`, "color: #00a859; font-weight: bold;");
            
            // Shared Comparison Utility
            window.compareExpenses = () => {
                const report = JSON.parse(localStorage.getItem('debugExpenseReport') || '[]');
                const list = JSON.parse(localStorage.getItem('debugAllExpenses') || '[]');
                
                const reportVatSum = report.reduce((sum, e) => sum + e.vat, 0);
                const listVatSum = list.reduce((sum, e) => sum + (Number(e.vat_amount_aed) || Number(e.vat_aed) || 0), 0);

                console.clear();
                console.log("%c🔍 [CROSS-TAB VAT AUDIT RESULT]", "color: white; background: blue; padding: 5px; font-weight: bold; font-size: 16px;");
                console.log(`Report VAT Sum: ${reportVatSum.toFixed(2)} | List VAT Sum: ${listVatSum.toFixed(2)}`);
                console.log(`Difference: ${(reportVatSum - listVatSum).toFixed(2)}`);
                
                const reportIds = report.map(e => e.id);
                const listIds = list.map(e => e.id);

                const missingInReport = list.filter(l => !reportIds.includes(l.id));
                const extraInReport = report.filter(r => !listIds.includes(r.id));

                if (missingInReport.length > 0) {
                    console.log(`%c❌ Items in List missing from Report (${missingInReport.length}):`, "color: red; font-weight: bold;");
                    missingInReport.forEach(l => console.log(`   - [${l.date}] "${l.narration}" | VAT: ${l.vat_amount_aed || l.vat_aed} | Total: ${l.amount}`));
                }

                if (extraInReport.length > 0) {
                    console.log(`%c➕ Items in Report missing from List (${extraInReport.length}):`, "color: blue; font-weight: bold;");
                    extraInReport.forEach(r => console.log(`   - [${r.date}] "${r.narration}" | VAT: ${r.vat} | Total: ${r.amount}`));
                }

                if (missingInReport.length === 0 && extraInReport.length === 0 && Math.abs(reportVatSum - listVatSum) > 0.01) {
                    console.log("%c⚠️ Counts match but Totals differ! Checking for single-row value mismatches...", "color: orange;");
                    report.forEach(r => {
                        const l = list.find(item => item.id === r.id);
                        if (l && Math.abs(r.vat - (l.vat_amount_aed || l.vat_aed)) > 0.01) {
                            console.log(`   - [ID: ${r.id}] VAT Mismatch: Report=${r.vat} | List=${l.vat_amount_aed || l.vat_aed}`);
                        }
                    });
                } else if (missingInReport.length === 0 && extraInReport.length === 0) {
                    console.log("%c✅ Perfect Match: All items and totals are synchronized!", "color: green; font-weight: bold;");
                }
            };

            console.log("📊 [ExpenseReport] Data Saved. Type 'compareExpenses()' to run audit.");
        } catch (error) {
            console.error("Error loading expense report:", error);
        } finally {
            setLoading(false);
        }
    };

    // Identical formatting to AllExpenseList.jsx
    const formatCurrency = (amount) => {
        return new Intl.NumberFormat('en-US', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
        }).format(amount || 0);
    };

    const convertToAED = (amount, currency) => {
        const numericAmount = parseFloat(amount) || 0;
        if (currency === 'USD') {
            // Priority 1: Use specific exchange rate from settings/storage
            const globalRate = parseFloat(companySettings?.usd_to_aed || localStorage.getItem('exchange_rate') || '3.67');
            return numericAmount * globalRate;
        }
        return numericAmount;
    };

    const fetchFilterOptions = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/expense-report/filter-options`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });
            setFilterOptions(response.data);
            if (response.data.expense_types && response.data.expense_types.length > 0) {
                const sorted = [...response.data.expense_types].sort((a, b) => (a.name || "").localeCompare(b.name || ""));
                setExpenseTypes(sorted);
            }
        } catch (error) {
            console.error("Error loading filter options:", error);
        }
    };

    const fetchExpenseTypes = async () => {
        try {
            const response = await axios.get(`${backendUrl}/api/expense-type`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
                skipLoader: true,
            });
            const list = response.data.expense || response.data.data || [];
            const sorted = list.sort((a, b) => (a.name || '').localeCompare(b.name || ''));
            setExpenseTypes(sorted);
        } catch (error) {
            console.error("Error loading expense types:", error);
        }
    };

    const calculateSummary = (data) => {
        console.log(`🧮 [ExpenseReport] Calculating summary for ${data?.length || 0} items...`);
        let totalAmount = 0;
        let totalVAT = 0;
        let adjustmentAmount = 0;
        let grandTotal = 0;
        let totalAmountAED = 0;
        let totalVATAED = 0;
        let adjustmentAmountAED = 0;
        let grandTotalAED = 0;
        let totalWpsCharge = 0;
        let totalWpsVat = 0;
        let totalWpsChargeAED = 0;
        let totalWpsVatAED = 0;
        let paymentMethods = {
            cash: 0,
            bank: 0,
            other: 0 // This will now represent "Unpaid" / Balance
        };
        let paymentMethodsAED = {
            cash: 0,
            bank: 0,
            other: 0 // This will now represent "Unpaid" / Balance
        };

        data.forEach(expense => {
            const amount = Number(expense.amount_excl_vat) || 0;
            const vat = Number(expense.vat_amount) || 0;
            const adjustment = Number(expense.adjustment_amount) || 0;
            const total = Number(expense.total) || 0;
            
            const amountAED = Number(expense.amount_aed) || 0;
            const vatAED = Number(expense.vat_amount_aed) || 0;
            const adjustmentAED = Number(expense.adjustment_amount_aed) || 0;
            const totalAED = Number(expense.total_aed) || 0;

            const paid = Number(expense.paid_amount) || 0;
            const balance = Number(expense.balance_amount) || 0;
            const paidAED = Number(expense.paid_amount_aed) || 0;
            const balanceAED = Number(expense.balance_amount_aed) || 0;

            const wpsCharge = Number(expense.wps_charge) || 0;
            const wpsVat = Number(expense.wps_vat) || 0;
            const wpsChargeAED = Number(expense.wps_charge_aed) || 0;
            const wpsVatAED = Number(expense.wps_vat_aed) || 0;

            totalAmount += amount;
            totalVAT += vat;
            adjustmentAmount += adjustment;
            grandTotal += total;

            totalAmountAED += amountAED;
            totalVATAED += vatAED;
            adjustmentAmountAED += adjustmentAED;
            grandTotalAED += totalAED;

            totalWpsCharge += wpsCharge;
            totalWpsVat += wpsVat;
            totalWpsChargeAED += wpsChargeAED;
            totalWpsVatAED += wpsVatAED;

            // Add balance to "Unpaid" (other)
            paymentMethods.other += balance;
            paymentMethodsAED.other += balanceAED;

            // Add paid amount to relevant mode
            if (expense.payment_mode === 'Cash') {
                paymentMethods.cash += paid;
                paymentMethodsAED.cash += paidAED;
            } else if (expense.payment_mode === 'Bank') {
                paymentMethods.bank += paid;
                paymentMethodsAED.bank += paidAED;
            } else if (paid > 0) {
                paymentMethods.cash += paid;
                paymentMethodsAED.cash += paidAED;
            }
        });

        const totalPaidAED = paymentMethodsAED.bank + paymentMethodsAED.cash;
        const totalBalanceAED = paymentMethodsAED.other;

        // Final precision totals for the summary state
        setSummary({
            totalAmount,
            totalVAT,
            adjustmentAmount,
            grandTotal: grandTotal || (totalAmount + totalVAT + adjustmentAmount + totalWpsCharge + totalWpsVat),
            totalAmountAED,
            totalVATAED,
            adjustmentAmountAED,
            grandTotalAED: grandTotalAED || (totalAmountAED + totalVATAED + adjustmentAmountAED + totalWpsChargeAED + totalWpsVatAED),
            totalPaidAED,
            totalBalanceAED,
            paymentMethods,
            paymentMethodsAED,
            totalWpsCharge,
            totalWpsVat,
            totalWpsChargeAED,
            totalWpsVatAED,
            total_count: data.length
        });
        console.log(`✅ [ExpenseReport] Summary Calculation Complete. Total VAT AED: ${totalVATAED.toFixed(2)}`);
    };

    const handleFilterChange = (e) => {
        const { name, value } = e.target;

        // If date range is selected, clear custom dates
        if (name === 'dateRange' && value !== 'custom') {
            setFilters(prev => ({
                ...prev,
                [name]: value,
                fromDate: '',
                toDate: ''
            }));
        } else {
            setFilters(prev => ({ ...prev, [name]: value }));
        }
    };

    const handleExpenseClick = (expense) => {
        setSelectedExpense(expense);
        setShowModal(true);
        setJournalDetails(null);
        if (expense.journal_id) {
            fetchJournalDetails(expense.journal_id);
        }
    };

    const fetchJournalDetails = async (journalId) => {
        try {
            setJournalLoading(true);
            const response = await axios.get(`${backendUrl}/api/expense-report/journal/${journalId}`, {
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                }
            });
            if (response.data.status === 'success') {
                setJournalDetails(response.data.data);
            }
        } catch (error) {
            console.error("Error fetching journal details:", error);
        } finally {
            setJournalLoading(false);
        }
    };

    const exportToExcel = async () => {
        try {
            const exportFilters = { ...filters };
            if (selectedExpenseTypes.length > 0) {
                exportFilters.expenseType = selectedExpenseTypes.join(',');
            }
            if (exportFilters.taxType) {
                exportFilters.tax_type = exportFilters.taxType;
            }
            const response = await axios.get(`${backendUrl}/api/expense-report/export`, {
                params: exportFilters,
                headers: {
                    Authorization: `Bearer ${token}`,
                    "Tenant-Origin": origin,
                },
                responseType: 'blob',
            });

            const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
            saveAs(blob, `Expense_Report_${moment().format('YYYYMMDD')}.xlsx`);
        } catch (error) {
            console.error("Error exporting expense report:", error);
        }
    };


    const clearFilters = () => {
        setFilters({
            dateRange: 'this_month',
            fromDate: '',
            toDate: '',
            project: '',
            vendor: '',
            client: '',
            category: '',
            expenseType: '',
            user: '',
            paymentStatus: '',
            taxType: '',
            source: []
        });
        setSelectedExpenseTypes([]);
        setTopSelectedExpenseTypes([]);
        setAvailableExpenseTypes([]);
        setExpenseTypeSearch('');
        setShowExpenseTypeDropdown(false);
        setApplyFilterClicked(false);
        setExpenses([]);
        setFilteredData([]);
        setSummary({
            totalAmount: 0,
            totalVAT: 0,
            adjustmentAmount: 0,
            grandTotal: 0,
            totalAmountAED: 0,
            totalVATAED: 0,
            adjustmentAmountAED: 0,
            grandTotalAED: 0,
            totalWpsCharge: 0,
            totalWpsVat: 0,
            totalWpsChargeAED: 0,
            totalWpsVatAED: 0,
            totalPaidAED: 0,
            totalBalanceAED: 0,
            paymentMethods: { cash: 0, bank: 0, other: 0 },
            paymentMethodsAED: { cash: 0, bank: 0, other: 0 },
            total_count: 0
        });
        setPageCount(0);
        setCurrentPage(0);
        // Don't fetch data immediately, wait for user to click Apply Filters
    };

    // Function to handle applying filters
    const applyFilters = () => {
        setApplyFilterClicked(true);
        setCurrentPage(0);
        const typeFilterString = topSelectedExpenseTypes.join(',');
        const updatedFilters = { ...filters, expenseType: typeFilterString };
        fetchData(0, updatedFilters, topSelectedExpenseTypes, false);
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
        fetchData(data.selected, filters, selectedExpenseTypes, true);
    };

    return (
        <div className="main-content" style={{ backgroundColor: '#f8f9fa' }}>
            <div className="page-content">
                <div className="container-fluid">
                    {/* Header Section */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="d-flex justify-content-between align-items-center">
                                <div>
                                    <h4 className="mb-0" style={{ color: '#2e3a4d', fontWeight: 600 }}>Expense Report</h4>

                                </div>
                                <button
                                    onClick={exportToExcel}
                                    className="btn btn-success"
                                    style={{
                                        backgroundColor: '#00a859',
                                        borderColor: '#00a859',
                                        borderRadius: '4px',
                                        padding: '8px 16px'
                                    }}
                                >
                                    <i className="mdi mdi-file-excel-outline me-2"></i> Export to Excel
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Filter Section - Same as before */}
                    {/* Filter Section */}
                    <div className="row mb-4">
                        <div className="col-12">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body p-3">
                                    <div className="row g-3">
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Date Range</label>
                                            <select
                                                name="dateRange"
                                                value={filters.dateRange}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="this_month">This Month</option>
                                                <option value="last_month">Last Month</option>
                                                <option value="this_quarter">This Quarter</option>
                                                <option value="last_quarter">Last Quarter</option>
                                                <option value="this_year">This Year</option>
                                                <option value="custom">Custom Date Range</option>
                                            </select>
                                        </div>

                                        {/* Custom Date Range Fields - Only show when "Custom" is selected */}
                                        {filters.dateRange === 'custom' && (
                                            <>
                                                {/* <div className="col-md-2">
                                                    <label className="form-label small text-muted mb-1">From Date</label>
                                                    <input
                                                        type="date"
                                                        name="fromDate"
                                                        value={filters.fromDate}
                                                        onChange={handleFilterChange}
                                                        className="form-control form-control-sm"
                                                    />
                                                </div> */}
                                                <div className="col-md-2">
                                                    <label className="form-label small text-muted mb-1">From Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            openTo="year"
                                                            format="DD-MM-YYYY"
                                                            value={filters.fromDate ? dayjs(filters.fromDate) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue) {
                                                                    const dateStr = newValue.format('YYYY-MM-DD');
                                                                    if (!filters.fromDate || dayjs(filters.fromDate).year() !== newValue.year()) {
                                                                        setFilters(prev => ({
                                                                            ...prev,
                                                                            fromDate: newValue.startOf('year').format('YYYY-MM-DD'),
                                                                            toDate: newValue.endOf('year').format('YYYY-MM-DD')
                                                                        }));
                                                                    } else {
                                                                        let newToDate = filters.toDate;
                                                                        if (filters.toDate && dayjs(dateStr).isAfter(dayjs(filters.toDate, "YYYY-MM-DD"), 'day')) {
                                                                            newToDate = dayjs(dateStr).endOf('month').format('YYYY-MM-DD');
                                                                        }
                                                                        setFilters(prev => ({
                                                                            ...prev,
                                                                            fromDate: dateStr,
                                                                            toDate: newToDate
                                                                        }));
                                                                    }
                                                                } else {
                                                                    setFilters(prev => ({ ...prev, fromDate: "" }));
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: {
                                                                        style: { fontSize: '11px', padding: '6px 12px' }
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>
                                                <div className="col-md-2">
                                                    <label className="form-label small text-muted mb-1">To Date</label>
                                                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                                                        <DatePicker
                                                            views={["year", "month", "day"]}
                                                            openTo="year"
                                                            format="DD-MM-YYYY"
                                                            value={filters.toDate ? dayjs(filters.toDate) : null}
                                                            onChange={(newValue) => {
                                                                if (newValue) {
                                                                    if (!filters.toDate || dayjs(filters.toDate).year() !== newValue.year()) {
                                                                        setFilters(prev => ({
                                                                            ...prev,
                                                                            toDate: newValue.endOf('year').format('YYYY-MM-DD')
                                                                        }));
                                                                    } else {
                                                                        const dateStr = newValue.format('YYYY-MM-DD');
                                                                        let newToDate = dateStr;
                                                                        if (filters.fromDate && dayjs(dateStr).isBefore(dayjs(filters.fromDate, "YYYY-MM-DD"), 'day')) {
                                                                            newToDate = dayjs(filters.fromDate).endOf('month').format('YYYY-MM-DD');
                                                                        }
                                                                        setFilters(prev => ({
                                                                            ...prev,
                                                                            toDate: newToDate
                                                                        }));
                                                                    }
                                                                } else {
                                                                    setFilters(prev => ({ ...prev, toDate: "" }));
                                                                }
                                                            }}
                                                            slotProps={{
                                                                textField: {
                                                                    size: "small",
                                                                    fullWidth: true,
                                                                    variant: "outlined",
                                                                    inputProps: {
                                                                        style: { fontSize: '11px', padding: '6px 12px' }
                                                                    }
                                                                },
                                                            }}
                                                        />
                                                    </LocalizationProvider>
                                                </div>

                                            </>
                                        )}

                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Project</label>
                                            <select
                                                name="project"
                                                value={filters.project}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Projects</option>
                                                {filterOptions.projects.map(project => (
                                                    <option key={project.id} value={project.id}>{project.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Vendor</label>
                                            <select
                                                name="vendor"
                                                value={filters.vendor}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Vendors</option>
                                                {filterOptions.vendors.map(vendor => (
                                                    <option key={vendor.id} value={vendor.id}>{vendor.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Client</label>
                                            <select
                                                name="client"
                                                value={filters.client}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Clients</option>
                                                {filterOptions.clients.map(client => (
                                                    <option key={client.id} value={client.id}>{client.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Expense Type</label>
                                            <Select
                                                isMulti
                                                placeholder="All Expense Types"
                                                options={[...expenseTypes].sort((a, b) => (a.name || "").localeCompare(b.name || "")).map(type => ({ value: String(type.id), label: type.name }))}
                                                value={expenseTypes
                                                    .filter(type => topSelectedExpenseTypes.includes(String(type.id)))
                                                    .map(type => ({ value: String(type.id), label: type.name }))
                                                }
                                                onChange={(selectedOptions) => {
                                                    const vals = selectedOptions ? selectedOptions.map(option => String(option.value)) : [];
                                                    setTopSelectedExpenseTypes(vals);
                                                    setFilters(prev => ({
                                                        ...prev,
                                                        expenseType: vals.join(',')
                                                    }));
                                                }}
                                                classNamePrefix="react-select"
                                                styles={{
                                                    control: (provided) => ({
                                                        ...provided,
                                                        minHeight: '31px',
                                                        fontSize: '11px',
                                                        borderColor: '#ced4da',
                                                        boxShadow: 'none',
                                                    }),
                                                    menu: (provided) => ({
                                                        ...provided,
                                                        zIndex: 9999,
                                                        fontSize: '12px'
                                                    }),
                                                    valueContainer: (provided) => ({
                                                        ...provided,
                                                        padding: '0 6px'
                                                    }),
                                                    input: (provided) => ({
                                                        ...provided,
                                                        margin: '0px'
                                                    }),
                                                    indicatorsContainer: (provided) => ({
                                                        ...provided,
                                                        height: '31px'
                                                    }),
                                                }}
                                            />
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">User</label>
                                            <select
                                                name="user"
                                                value={filters.user}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Users</option>
                                                {filterOptions.users && filterOptions.users.map(user => (
                                                    <option key={user.id} value={user.id}>{user.name}</option>
                                                ))}
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Payment Status</label>
                                            <select
                                                name="paymentStatus"
                                                value={filters.paymentStatus}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Status</option>
                                                <option value="Paid">Paid</option>
                                                <option value="Partial">Partial</option>
                                                <option value="Unpaid">Unpaid</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Tax Type</label>
                                            <select
                                                name="taxType"
                                                value={filters.taxType}
                                                onChange={handleFilterChange}
                                                className="form-select form-select-sm"
                                            >
                                                <option value="">All Tax Types</option>
                                                <option value="taxable">Taxable</option>
                                                <option value="non-taxable">Non-Taxable</option>
                                                <option value="rcm">RCM</option>
                                            </select>
                                        </div>
                                        <div className="col-md-2">
                                            <label className="form-label small text-muted mb-1">Source</label>
                                            <Select
                                                isMulti
                                                options={[
                                                    { value: 'direct', label: 'Direct' },
                                                    { value: 'pettycash', label: 'Petty Cash' },
                                                    { value: 'salary', label: 'Salary' }
                                                ]}
                                                value={[
                                                    { value: 'direct', label: 'Direct' },
                                                    { value: 'pettycash', label: 'Petty Cash' },
                                                    { value: 'salary', label: 'Salary' }
                                                ].filter(option => filters.source.includes(option.value))}
                                                onChange={(selectedOptions) => {
                                                    setFilters(prev => ({
                                                        ...prev,
                                                        source: selectedOptions ? selectedOptions.map(option => option.value) : []
                                                    }));
                                                }}
                                                styles={{
                                                    control: (base) => ({
                                                        ...base,
                                                        minHeight: '31px',
                                                        fontSize: '11px',
                                                        borderColor: '#ced4da',
                                                        boxShadow: 'none',
                                                        '&:hover': { borderColor: '#b3b3b3' }
                                                    }),
                                                    menu: (base) => ({
                                                        ...base,
                                                        zIndex: 9999,
                                                        fontSize: '11px'
                                                    }),
                                                    valueContainer: (base) => ({
                                                        ...base,
                                                        padding: '0px 8px',
                                                    }),
                                                    indicatorsContainer: (base) => ({
                                                        ...base,
                                                        height: '31px'
                                                    }),
                                                    multiValue: (base) => ({
                                                        ...base,
                                                        backgroundColor: '#e9ecef',
                                                        margin: '1px'
                                                    }),
                                                    multiValueLabel: (base) => ({
                                                        ...base,
                                                        fontSize: '10px',
                                                        padding: '1px 4px',
                                                        color: '#495057'
                                                    })
                                                }}
                                                placeholder="Select Source..."
                                                className="react-select-container"
                                                classNamePrefix="react-select"
                                            />
                                        </div>
                                        <div className="col-md-2 d-flex align-items-end gap-1">
                                            <button
                                                onClick={applyFilters}
                                                className="btn btn-primary btn-sm font-size-11"
                                                style={{ height: '32px', padding: '0 10px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                            >
                                                <i className="mdi mdi-filter-outline me-1"></i> Apply
                                            </button>
                                            <button
                                                onClick={clearFilters}
                                                className="btn btn-secondary btn-sm font-size-11"
                                                style={{ width: '60px', height: '32px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}
                                            >
                                                Clear
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Summary Cards - Update to show AED totals */}
                    {/* <div className="row mb-4">
                        <div className="col-md-4">
                            <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="text-muted mb-2">Total Expenses</h6>
                                            <h3 className="mb-0" style={{ color: '#2e3a4d' }}>{formatCurrency(summary.grandTotalAED)} AED</h3>
                                           
                                        </div>
                                        <div className="bg-primary bg-opacity-10 p-3 rounded">
                                            <i className="mdi mdi-cash-multiple text-primary" style={{ fontSize: '24px' }}></i>
                                        </div>
                                    </div>
                                    <div className="mt-3">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Amount (excl. VAT)</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.totalAmountAED)} AED</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Adjustment Amount</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.adjustmentAmountAED)} AED</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">VAT Amount</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.totalVATAED)} AED</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-8">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    <h6 className="card-title mb-3" style={{ color: '#2e3a4d' }}>Payment Methods Breakdown (AED)</h6>
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-primary bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-bank text-primary"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Bank Transfer</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.bank)} AED</h5>
                                                  
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-success bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-cash text-success"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Cash</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.cash)} AED</h5>
                                                  
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-secondary bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-wallet text-secondary"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Unpaid</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.other)} AED</h5>
                                                 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> */}
                    {/* Summary Cards */}
                    <div className="row mb-4">
                        <div className="col-md-4">
                            <div className="card border-0 shadow-sm" style={{ backgroundColor: '#f8f9fa' }}>
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center">
                                        <div>
                                            <h6 className="text-muted mb-2">Total Expenses</h6>
                                            <h3 className="mb-0" style={{ color: '#2e3a4d' }}>
                                                {formatCurrency(summary.grandTotalAED)} AED
                                            </h3>

                                        </div>

                                    </div>
                                    <div className="mt-3">
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Amount (excl. VAT)</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.totalAmountAED)} AED</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">Adjustment Amount</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.adjustmentAmountAED)} AED</div>
                                            </div>
                                        </div>
                                        <div className="d-flex justify-content-between">
                                            <span className="text-muted small">VAT Amount</span>
                                            <div className="text-end">
                                                <div>{formatCurrency(summary.totalVATAED)} AED</div>
                                            </div>
                                        </div>
                                        {(summary.totalWpsChargeAED > 0 || summary.totalWpsVatAED > 0) && (
                                            <>
                                                <div className="d-flex justify-content-between mt-1 pt-1 border-top">
                                                    <span className="text-muted small">WPS Charge</span>
                                                    <div className="text-end">
                                                        <div>{formatCurrency(summary.totalWpsChargeAED)} AED</div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-between">
                                                    <span className="text-muted small">WPS VAT</span>
                                                    <div className="text-end">
                                                        <div>{formatCurrency(summary.totalWpsVatAED)} AED</div>
                                                    </div>
                                                </div>
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className="col-md-8">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    {/* Total Paid & Balance Summary */}
                                    <div className="row mb-3 pb-3 border-bottom">
                                        <div className="col-md-6 border-end">
                                            <h6 className="text-muted mb-2">Total Paid</h6>
                                            <h3 className="mb-0" style={{ color: '#00a859' }}>
                                                {formatCurrency(summary.totalPaidAED)} AED
                                            </h3>
                                        </div>
                                        <div className="col-md-6 ps-4">
                                            <h6 className="text-muted mb-2">Total Balance (Unpaid)</h6>
                                            <h3 className="mb-0" style={{ color: '#dc3545' }}>
                                                {formatCurrency(summary.totalBalanceAED)} AED
                                            </h3>
                                        </div>
                                    </div>

                                    {/* Payment Methods Breakdown */}
                                    <div className="row">
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-light bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-bank text-black"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Bank Transfer</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.bank)} AED</h5>
                                                    <small className="text-muted">
                                                        {((summary.paymentMethodsAED.bank /
                                                            (summary.paymentMethodsAED.bank +
                                                                summary.paymentMethodsAED.cash +
                                                                summary.paymentMethodsAED.other || 1)) * 100).toFixed(1)}%
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-success bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-cash text-success"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Cash</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.cash)} AED</h5>
                                                    <small className="text-muted">
                                                        {((summary.paymentMethodsAED.cash /
                                                            (summary.paymentMethodsAED.bank +
                                                                summary.paymentMethodsAED.cash +
                                                                summary.paymentMethodsAED.other || 1)) * 100).toFixed(1)}%
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-md-4">
                                            <div className="d-flex align-items-center mb-3">
                                                <div className="bg-secondary bg-opacity-10 p-2 rounded me-3">
                                                    <i className="mdi mdi-wallet text-secondary"></i>
                                                </div>
                                                <div>
                                                    <p className="text-muted mb-0 small">Unpaid</p>
                                                    <h5 className="mb-0">{formatCurrency(summary.paymentMethodsAED.other)} AED</h5>
                                                    <small className="text-muted">
                                                        {((summary.paymentMethodsAED.other /
                                                            (summary.paymentMethodsAED.bank +
                                                                summary.paymentMethodsAED.cash +
                                                                summary.paymentMethodsAED.other || 1)) * 100).toFixed(1)}%
                                                    </small>
                                                </div>
                                            </div>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Expense Table - Updated with AED columns */}
                    <div className="row">
                        <div className="col-12">
                            <div className="card border-0 shadow-sm">
                                <div className="card-body">
                                    {!applyFilterClicked ? (
                                        <div className="text-center py-5">
                                            <i className="mdi mdi-filter-outline text-muted" style={{ fontSize: '48px' }}></i>
                                            <h5 className="mt-3" style={{ color: '#2e3a4d' }}>Please apply filters to view data</h5>
                                            <p className="text-muted">Select your filter criteria and click Apply to view results.</p>
                                        </div>
                                    ) : expenses.length === 0 ? (
                                        <div className="text-center py-5">
                                            <i className="mdi mdi-file-document-outline text-muted" style={{ fontSize: '48px' }}></i>
                                            <h5 className="mt-3" style={{ color: '#2e3a4d' }}>No expenses found</h5>
                                            <p className="text-muted">Try adjusting your filters or add new expenses</p>
                                        </div>
                                    ) : (
                                        <div className="table-responsive" style={{ minHeight: showExpenseTypeDropdown ? '460px' : '300px', paddingBottom: showExpenseTypeDropdown ? '80px' : '0' }}>
                                            <table className="table align-middle table-nowrap table-check table-list">
                                                <thead className='table-sales-gradient'>
                                                    <tr>
                                                        <th style={{ width: '20px' }} className="align-middle">
                                                            <div className="form-check font-size-16">
                                                                <input className="form-check-input" type="checkbox" id="checkAll" />
                                                                <label className="form-check-label" htmlFor="checkAll"></label>
                                                            </div>
                                                        </th>
                                                        <th className="align-middle">#</th>
                                                        <th className="border-0">Date</th>
                                                        <th className="border-0">
                                                            <div className="d-flex justify-content-center">
                              <div style={{ width: '150px', textAlign: 'left' }}>
                                                            Description</div>
                                                        </div>
                                                        </th>
                                                        <th className="border-0">
                                                            <div className="d-flex align-items-center">
                                                                <span className="me-1">Expense Type</span>
                                                                <div className="dropdown d-inline-block position-relative" ref={expenseTypeFilterRef}>
                                                                    {(() => {
                                                                        const hasActiveTypeFilter = (filters.expenseType === '__none__') ||
                                                                            (availableExpenseTypes.length > 0 && selectedExpenseTypes.length < availableExpenseTypes.length) ||
                                                                            (topSelectedExpenseTypes.length > 0);
                                                                        return (
                                                                            <button
                                                                                type="button"
                                                                                className={`btn btn-sm p-1 border-0 ${hasActiveTypeFilter ? 'text-primary' : 'text-muted'}`}
                                                                                onClick={(e) => {
                                                                                    e.stopPropagation();
                                                                                    setShowExpenseTypeDropdown(!showExpenseTypeDropdown);
                                                                                }}
                                                                                title="Filter by Expense Type"
                                                                                style={{
                                                                                    cursor: 'pointer',
                                                                                    background: hasActiveTypeFilter ? '#e8f0fe' : 'transparent',
                                                                                    borderRadius: '4px',
                                                                                    lineHeight: 1
                                                                                }}
                                                                            >
                                                                                <FaFilter size={11} className={hasActiveTypeFilter ? 'text-primary' : ''} />
                                                                                {hasActiveTypeFilter && (
                                                                                    <span className="badge bg-primary rounded-pill ms-1" style={{ fontSize: '9px', padding: '2px 4px' }}>
                                                                                        {selectedExpenseTypes.length}
                                                                                    </span>
                                                                                )}
                                                                            </button>
                                                                        );
                                                                    })()}

                                                                    {showExpenseTypeDropdown && (
                                                                        <div
                                                                            className="dropdown-menu show shadow-lg p-0"
                                                                            style={{
                                                                                position: 'absolute',
                                                                                top: '100%',
                                                                                left: 0,
                                                                                zIndex: 1050,
                                                                                minWidth: '270px',
                                                                                maxWidth: '340px',
                                                                                borderRadius: '8px',
                                                                                border: '1px solid #dee2e6',
                                                                                backgroundColor: '#ffffff',
                                                                                display: 'flex',
                                                                                flexDirection: 'column',
                                                                                boxShadow: '0 8px 24px rgba(0,0,0,0.18)'
                                                                            }}
                                                                            onClick={(e) => e.stopPropagation()}
                                                                        >
                                                                            {/* Header */}
                                                                            <div className="p-2 border-bottom bg-light d-flex justify-content-between align-items-center flex-shrink-0">
                                                                                <span className="fw-semibold font-size-12 text-dark">
                                                                                    Filter by Expense Type
                                                                                </span>
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn-close font-size-11"
                                                                                    aria-label="Close"
                                                                                    onClick={() => setShowExpenseTypeDropdown(false)}
                                                                                ></button>
                                                                            </div>

                                                                            {/* Search */}
                                                                            <div className="p-2 border-bottom flex-shrink-0">
                                                                                <div className="input-group input-group-sm">
                                                                                    <span className="input-group-text bg-white border-end-0 py-1">
                                                                                        <FaSearch size={10} className="text-muted" />
                                                                                    </span>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control form-control-sm border-start-0 py-1"
                                                                                        placeholder="Search types..."
                                                                                        value={expenseTypeSearch}
                                                                                        onChange={(e) => setExpenseTypeSearch(e.target.value)}
                                                                                        style={{ fontSize: '12px' }}
                                                                                    />
                                                                                    {expenseTypeSearch && (
                                                                                        <button
                                                                                            className="btn btn-outline-secondary border-start-0 py-1"
                                                                                            type="button"
                                                                                            onClick={() => setExpenseTypeSearch('')}
                                                                                        >
                                                                                            <FaTimes size={10} />
                                                                                        </button>
                                                                                    )}
                                                                                </div>
                                                                            </div>

                                                                            {/* Select All */}
                                                                            {(() => {
                                                                                const visibleTypes = [...availableExpenseTypes].filter(t =>
                                                                                    (t.name || '').toLowerCase().includes(expenseTypeSearch.toLowerCase())
                                                                                );
                                                                                const allVisibleSelected = visibleTypes.length > 0 &&
                                                                                    visibleTypes.every(t => isTypeSelected(t.id));
                                                                                const selectedCount = visibleTypes.filter(t => isTypeSelected(t.id)).length;

                                                                                return (
                                                                                    <>
                                                                                        <div className="px-3 py-2 border-bottom bg-light bg-opacity-50 flex-shrink-0">
                                                                                            <div className="form-check form-check-sm mb-0">
                                                                                                <input
                                                                                                    className="form-check-input"
                                                                                                    type="checkbox"
                                                                                                    id="selectAllExpenseTypes"
                                                                                                    checked={allVisibleSelected}
                                                                                                    onChange={() => handleSelectAllVisibleExpenseTypes(visibleTypes)}
                                                                                                    style={{
                                                                                                        cursor: 'pointer',
                                                                                                        borderColor: allVisibleSelected ? '#0d6efd' : '#9ec5fe',
                                                                                                        borderWidth: '2px',
                                                                                                        boxShadow: allVisibleSelected ? 'none' : '0 0 0 1px rgba(13, 110, 253, 0.15)'
                                                                                                    }}
                                                                                                />
                                                                                                <label
                                                                                                    className="form-check-label fw-bold text-dark font-size-12 ms-1"
                                                                                                    htmlFor="selectAllExpenseTypes"
                                                                                                    style={{ cursor: 'pointer' }}
                                                                                                >
                                                                                                    (Select All)
                                                                                                </label>
                                                                                                <span className="text-muted font-size-11 float-end">
                                                                                                    {selectedCount}/{availableExpenseTypes.length}
                                                                                                </span>
                                                                                            </div>
                                                                                        </div>

                                                                                        {/* List */}
                                                                                        <div style={{ maxHeight: '150px', overflowY: 'auto' }} className="p-2 flex-grow-1">
                                                                                            {visibleTypes.length === 0 ? (
                                                                                                <div className="text-muted text-center py-3 font-size-12">
                                                                                                    No expense types in current list
                                                                                                </div>
                                                                                            ) : (
                                                                                                visibleTypes.map((type) => {
                                                                                                    const isChecked = isTypeSelected(type.id);
                                                                                                    return (
                                                                                                        <div
                                                                                                            key={type.id}
                                                                                                            className="form-check py-1 px-3 rounded hover-bg-light"
                                                                                                            style={{ cursor: 'pointer', transition: 'background-color 0.15s' }}
                                                                                                            onClick={() => handleToggleExpenseType(type.id)}
                                                                                                        >
                                                                                                            <input
                                                                                                                className="form-check-input"
                                                                                                                type="checkbox"
                                                                                                                id={`expenseType_${type.id}`}
                                                                                                                checked={isChecked}
                                                                                                                onChange={() => {}}
                                                                                                                style={{
                                                                                                                    cursor: 'pointer',
                                                                                                                    borderColor: isChecked ? '#0d6efd' : '#9ec5fe',
                                                                                                                    borderWidth: '2px'
                                                                                                                }}
                                                                                                            />
                                                                                                            <label
                                                                                                                className="form-check-label font-size-12 ms-1 text-truncate d-block"
                                                                                                                htmlFor={`expenseType_${type.id}`}
                                                                                                                style={{ cursor: 'pointer', maxWidth: '240px' }}
                                                                                                                title={type.name}
                                                                                                            >
                                                                                                                {type.name}
                                                                                                            </label>
                                                                                                        </div>
                                                                                                    );
                                                                                                })
                                                                                            )}
                                                                                        </div>
                                                                                    </>
                                                                                );
                                                                            })()}

                                                                            {/* Footer Actions */}
                                                                            <div className="p-2 border-top bg-light d-flex justify-content-between align-items-center flex-shrink-0">
                                                                                <button
                                                                                    type="button"
                                                                                    className="btn btn-outline-secondary btn-sm font-size-11 py-1 px-2"
                                                                                    onClick={clearExpenseTypeFilter}
                                                                                >
                                                                                    Clear
                                                                                </button>
                                                                                <div className="d-flex gap-1">
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-light btn-sm font-size-11 py-1 px-2"
                                                                                        onClick={() => setShowExpenseTypeDropdown(false)}
                                                                                    >
                                                                                        Cancel
                                                                                    </button>
                                                                                    <button
                                                                                        type="button"
                                                                                        className="btn btn-primary btn-sm font-size-11 py-1 px-3 fw-medium"
                                                                                        onClick={() => applyExpenseTypeFilter()}
                                                                                    >
                                                                                        Apply
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </th>
                                                        <th className="border-0">Vendor/Client</th>
                                                        <th className="border-0">User</th>
                                                        <th className="border-0 text-end">Amount</th>
                                                        <th className="border-0 text-end">Amount (AED)</th>
                                                        <th className="border-0 text-end">VAT(5%)</th>
                                                        <th className="border-0 text-end">VAT (AED)</th>
                                                        <th className="border-0">Adjustment</th>
                                                        <th className="border-0">Adjustment (AED)</th>
                                                        <th className="border-0 text-end">Total</th>
                                                        <th className="border-0 text-end">Total (AED)</th>
                                                        <th className="border-0 text-end">Paid Amount (AED)</th>
                                                        <th className="border-0 text-end">Balance (AED)</th>
                                                        <th className="border-0">Payment</th>
                                                        {/* <th className="border-0">Tax</th> */}
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {expenses.map((expense, index) => (
                                                        <tr 
                                                            key={index} 
                                                            style={{ borderBottom: '1px solid #f1f3f9', cursor: 'pointer' }}
                                                            onClick={() => handleExpenseClick(expense)}
                                                        >
                                                            <td>
                                                                <div className="form-check font-size-16">
                                                                    <input
                                                                        className="form-check-input"
                                                                        type="checkbox"
                                                                        id={`transactionCheck${index}`}
                                                                    />
                                                                    <label
                                                                        className="form-check-label"
                                                                        htmlFor={`transactionCheck${index}`}
                                                                    ></label>
                                                                </div>
                                                            </td>
                                                            <td>{index + 1}</td>

                                                            <td style={{ color: '#6c757d' }} className="text-nowrap">
                                                                {expense.date ? dayjs(expense.date).format('DD-MM-YYYY') : ''}
                                                            </td>
                                                            <td style={{ minWidth: '200px', whiteSpace: 'normal' }}>
                                                                <div className="d-flex justify-content-center">
                              <div style={{ width: '150px', textAlign: 'left' }}>
                                                                <span
                                                                    className="d-block fw-medium"
                                                                    style={{ color: '#2e3a4d', wordBreak: 'break-word', whiteSpace: 'normal' }}
                                                                    title={expense.narration || expense.description || ''}
                                                                >
                                                                    {expense.narration || expense.description || '-'}
                                                                </span>
                                                                {expense.invoice_no && <small className="text-muted d-block">Inv: {expense.invoice_no}</small>}
                                                            </div></div>
                                                            </td>
                                                            <td title={expense.expenseType?.name || expense.expense_type?.name || expense.expense_type_name || expense.type || ''}>
                                                                <div className="text-truncate" style={{ maxWidth: '160px' }}>
                                                                     <div className="d-flex justify-content-center">
                              <div style={{ width: '150px', textAlign: 'left' }}>
                                                                    {expense.expenseType?.name || expense.expense_type?.name || expense.expense_type_name || expense.type || '-'}
                                                                </div></div>
                                                                </div>
                                                            </td>
                                                            <td title={expense.vendor?.name || expense.client?.name}>
                                                                <div className="text-truncate" style={{ maxWidth: '120px' }}>
                                                                    {expense.vendor?.name || expense.client?.name || ''}
                                                                </div>
                                                            </td>
                                                            <td>{expense.user?.name || ''}</td>
                                                            <td className="text-end">
                                                                {formatCurrency(expense.amount_excl_vat)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td className="text-end fw-medium">
                                                                {formatCurrency(expense.amount_aed)}
                                                                {/* <div className="text-muted small">AED</div> */}
                                                            </td>
                                                            <td className="text-end">
                                                                {(Number(expense.vat_amount) > 0 || (expense.tax_type && expense.tax_type.toLowerCase() === 'taxable')) ? (
                                                                    <span className="text-success">
                                                                        {formatCurrency(expense.vat_amount)}
                                                                    </span>
                                                                ) : '-'}
                                                            </td>
                                                            <td className="text-end">
                                                                {(Number(expense.vat_amount_aed) > 0 || Number(expense.vat_amount) > 0 || (expense.tax_type && expense.tax_type.toLowerCase() === 'taxable')) ? (
                                                                    <span className="text-success fw-medium">
                                                                        {formatCurrency(Number(expense.vat_amount_aed) || convertToAED(expense.vat_amount, expense.vendor_currency))}
                                                                    </span>
                                                                ) : '-'}
                                                            </td>
                                                            <td>
                                                                {formatCurrency(expense.adjustment_amount || 0)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td>
                                                                {formatCurrency(expense.adjustment_amount_aed || 0)}
                                                                {/* <div className="text-muted small">AED</div> */}
                                                            </td>
                                                            <td className="text-end fw-medium" style={{ color: '#2e3a4d' }}>
                                                                {formatCurrency(expense.total)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td className="text-end fw-bold" style={{ color: '#00a859' }}>
                                                                {formatCurrency(expense.total_aed)}
                                                                {/* <div className="text-muted small">AED</div> */}
                                                            </td>
                                                            <td className="text-end text-success">
                                                                {formatCurrency(expense.paid_amount_aed || 0)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td className="text-end text-danger">
                                                                {formatCurrency(expense.balance_amount_aed || 0)}
                                                                {/* <div className="text-muted small">
                                                                    {expense.vendor_currency}
                                                                </div> */}
                                                            </td>
                                                            <td>
                                                                <span className={`badge ${expense.payment_status === 'Paid' ? 'bg-success' :
                                                                    expense.payment_status === 'Partial' ? 'bg-warning' :
                                                                        'bg-danger'
                                                                    }`}>
                                                                    {expense.payment_status}
                                                                </span>
                                                                {/* <div className="small text-muted mt-1">{expense.payment_mode}</div> */}
                                                            </td>
                                                            {/* <td>
                                                                <span className={`badge ${expense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
                                                                    {expense.tax_type || 'N/A'}
                                                                </span>
                                                            </td> */}
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot style={{ backgroundColor: '#f8f9fa' }}>
                                                    <tr>
                                                        <th colSpan="7" className="text-end">Totals:</th>
                                                        <th className="text-end">{formatCurrency(summary.totalAmount)}</th>
                                                        <th className="text-end fw-medium">{formatCurrency(summary.totalAmountAED)} AED</th>
                                                        <th className="text-end text-success">{formatCurrency(summary.totalVAT)}</th>
                                                        <th className="text-end text-success fw-medium">{formatCurrency(summary.totalVATAED)} AED</th>
                                                        <th className="text-end">{formatCurrency(summary.adjustmentAmount)}</th>
                                                        <th className="text-end">{formatCurrency(summary.adjustmentAmountAED)} AED</th>
                                                        <th className="text-end fw-medium">{formatCurrency(summary.grandTotal)}</th>
                                                        <th className="text-end fw-bold" style={{ color: '#00a859' }}>
                                                            {formatCurrency(summary.grandTotalAED)} AED
                                                        </th>
                                                        <th className="text-end fw-bold text-success">
                                                            {formatCurrency(summary.totalPaidAED || (summary.paymentMethodsAED.bank + summary.paymentMethodsAED.cash))} AED
                                                        </th>
                                                        <th className="text-end fw-bold text-danger">
                                                            {formatCurrency(summary.totalBalanceAED || summary.paymentMethodsAED.other)} AED
                                                        </th>
                                                        <th></th>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    )}

                                    {/* Pagination */}
                                    {applyFilterClicked && expenses.length > 0 && (
                                        <div className="d-flex justify-content-between align-items-center mt-3">
                                            <div className="text-muted small">
                                                Showing {currentPage * itemsPerPage + 1} to {Math.min((currentPage + 1) * itemsPerPage, summary.total_count || expenses.length)} of {summary.total_count || expenses.length} entries
                                            </div>
                                            <ReactPaginate
                                                previousLabel={<i className="mdi mdi-chevron-left"></i>}
                                                nextLabel={<i className="mdi mdi-chevron-right"></i>}
                                                pageCount={pageCount}
                                                onPageChange={handlePageClick}
                                                containerClassName={"pagination pagination-sm mb-0"}
                                                pageClassName={"page-item"}
                                                pageLinkClassName={"page-link"}
                                                previousClassName={"page-item"}
                                                previousLinkClassName={"page-link"}
                                                nextClassName={"page-item"}
                                                nextLinkClassName={"page-link"}
                                                activeClassName={"active"}
                                                forcePage={currentPage}
                                            />
                                        </div>
                                    )}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Offcanvas
                show={showModal}
                onHide={() => setShowModal(false)}
                placement="end"
                style={{ width: '600px' }}
            >
                <Offcanvas.Header closeButton className="border-bottom">
                    <Offcanvas.Title className="text-primary">
                        <i className="mdi mdi-receipt me-2"></i>
                        Expense Details
                    </Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    {selectedExpense && (
                        <div>
                            {/* Expense Header Card */}
                            <div className="card shadow-sm mb-4 border-0 bg-light">
                                <div className="card-body">
                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                        <div>
                                            <h6 className="text-muted mb-1">Expense Date</h6>
                                            <p className="mb-0 fw-bold">{moment(selectedExpense.date).format('DD MMM YYYY')}</p>
                                        </div>
                                        <div className="text-end">
                                            <h6 className="text-muted mb-1">Reference</h6>
                                            <span className="badge bg-primary">{selectedExpense?.transaction?.reference || ''}</span>
                                        </div>
                                    </div>

                                    <div className="mt-3">
                                        <h6 className="text-muted mb-1">Description</h6>
                                        <p className="mb-0 fw-semibold">{selectedExpense.narration || selectedExpense.description}</p>
                                    </div>
                                </div>
                            </div>

                            {/* Basic Information */}
                            <div className="row mb-4">
                                <div className="col-md-12">
                                    <div className="card border-0 shadow-sm mb-3">
                                        <div className="card-body">
                                            <h6 className="text-muted mb-2">Basic Information</h6>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">
                                                    {selectedExpense.vendor ? 'Vendor' : 'User'}
                                                </span>
                                                <span className="fw-medium">
                                                    {selectedExpense.vendor ? selectedExpense.vendor?.name : selectedExpense.user?.name || ''}
                                                </span>
                                            </div>


                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Project:</span>
                                                <span className="fw-medium">{selectedExpense.project?.name || ''}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Expense Type:</span>
                                                <span className="fw-medium">{selectedExpense.type || selectedExpense.expense_type?.name || selectedExpense.category || ''}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Invoice No:</span>
                                                <span className="fw-medium">{selectedExpense.invoice_no || ''}</span>
                                            </div>
                                            {/* <div className="d-flex justify-content-between">
                                                <span className="small text-muted">Entered By:</span>
                                                <span className="fw-medium">{selectedExpense.user?.name || 'N/A'}</span>
                                            </div> */}
                                        </div>
                                    </div>
                                </div>

                                {/* <div className="col-md-6">
                                    <div className="card border-0 shadow-sm mb-3">
                                        <div className="card-body">
                                            <h6 className="text-muted mb-2">Financial Details</h6>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Amount:</span>
                                                <span className="fw-medium">{formatCurrency(selectedExpense.amount_excl_vat)}
                                                                                                                              <span className="text-muted ms-1 font-size-11">
                                                                                                                                {selectedExpense.vendor_currency}

                                                </span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">VAT ({selectedExpense.vat_percent || 0}%):</span>
                                                <span className="text-success">{formatCurrency(selectedExpense.vat_amount || 0)}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Adjustment Amount:</span>
                                                <span className="text-success">{formatCurrency(selectedExpense.adjustment_amount || 0)}</span>
                                            </div>
                                            <div className="d-flex justify-content-between mb-2">
                                                <span className="small text-muted">Total:</span>
                                                <span className="fw-bold text-primary">{formatCurrency(selectedExpense.total)}
                                                                                                                            <span className="text-muted ms-1 font-size-11">
                                                                                                                                {selectedExpense.vendor_currency}

                                                </span>
                                                </span>
                                            </div>
                                            <div className="d-flex justify-content-between">
                                                <span className="small text-muted">Tax Type:</span>
                                                <span className={`badge ${selectedExpense.tax_type === 'taxable' ? 'bg-info' : 'bg-light text-dark'}`}>
                                                    {selectedExpense.tax_type || 'N/A'}
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div> */}
                            </div>
                            <div className="col-md-12">
                                <div className="card border-0 shadow-sm mb-3">
                                    <div className="card-body">
                                        <h6 className="text-muted mb-2">Financial Details (Currency Conversion)</h6>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Amount (AED):</span>
                                            <span className="fw-medium text-primary">
                                                {formatCurrency(selectedExpense.amount_aed || selectedExpense.amount_excl_vat)} AED
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">VAT Amount (AED):</span>
                                            <span className="text-success">
                                                {formatCurrency(selectedExpense.vat_amount_aed || selectedExpense.vat_amount || 0)} AED
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Adjustment (AED):</span>
                                            <span className="text-success">
                                                {formatCurrency(selectedExpense.adjustment_amount_aed || selectedExpense.adjustment_amount || 0)} AED
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Total (AED):</span>
                                            <span className="fw-bold text-success">
                                                {formatCurrency(selectedExpense.total_aed || selectedExpense.total)} AED
                                            </span>
                                        </div>

                                        {/* USD Conversion if applicable */}
                                        {(() => {
                                            // Find matched bank for conversion
                                            const matchedBank = bankAccounts.find(b => 
                                                b.name?.trim().toLowerCase() === selectedExpense.account_name?.trim().toLowerCase() ||
                                                selectedExpense.transactions?.some(tx => b.name?.trim().toLowerCase() === tx.account_name?.trim().toLowerCase())
                                            );
                                            
                                            const globalRate = parseFloat(companySettings?.usd_to_aed || localStorage.getItem('exchange_rate') || '3.67');
                                            let displayRate = "1:1 (AED)";
                                            let usdAmount = 0;
                                            let showUSD = false;

                                            if (matchedBank) {
                                                const bankCurrency = (matchedBank.base_currency?.currency || matchedBank.currency?.currency || matchedBank.currency || 'AED').toString().trim().toUpperCase();
                                                if (bankCurrency === 'USD') {
                                                    showUSD = true;
                                                    const aedRateObj = matchedBank.exchange_rates?.find(r =>
                                                        (r.currency?.currency || r.currency || '').toString().trim().toUpperCase() === 'AED'
                                                    );
                                                    const totalAED = parseFloat(selectedExpense.total_aed || selectedExpense.total || 0);
                                                    
                                                    if (aedRateObj) {
                                                        const rate = parseFloat(aedRateObj.rate || aedRateObj.exchange_rate || 0);
                                                        if (rate > 0) {
                                                            usdAmount = totalAED * rate;
                                                            displayRate = `1 AED = ${rate} USD`;
                                                        }
                                                    } else if (globalRate > 0) {
                                                        usdAmount = totalAED / globalRate;
                                                        displayRate = `1 USD = ${globalRate} AED (Global)`;
                                                    }
                                                }
                                            } else if (selectedExpense.vendor_currency === 'USD') {
                                                showUSD = true;
                                                const totalAED = parseFloat(selectedExpense.total_aed || selectedExpense.total || 0);
                                                usdAmount = totalAED / globalRate;
                                                displayRate = `1 USD = ${globalRate} AED (Fallback)`;
                                            }

                                            if (showUSD) {
                                                return (
                                                    <>
                                                        <div className="d-flex justify-content-between mb-2 border-top pt-2">
                                                            <span className="small text-muted">Total (USD):</span>
                                                            <span className="fw-bold text-info">
                                                                USD {usdAmount.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}
                                                            </span>
                                                        </div>
                                                        <div className="d-flex justify-content-between">
                                                            <span className="small text-muted">Exchange Rate:</span>
                                                            <span className="fw-medium small">
                                                                {displayRate}
                                                            </span>
                                                        </div>
                                                    </>
                                                );
                                            }
                                            return (
                                                <div className="d-flex justify-content-between border-top pt-2">
                                                    <span className="small text-muted">Exchange Rate:</span>
                                                    <span className="fw-medium small">
                                                        {displayRate}
                                                    </span>
                                                </div>
                                            );
                                        })()}
                                    </div>
                                </div>
                            </div>

                            {/* Journal Details Section */}
                            <div className="card border-0 shadow-sm mb-4">
                                <div className="card-body">
                                    <h6 className="text-muted mb-3">
                                        <i className="mdi mdi-book-open-variant me-1"></i>
                                        Journal Entry Details
                                    </h6>
                                    
                                    {selectedExpense.journal_id ? (
                                        journalLoading ? (
                                            <div className="text-center py-3">
                                                <div className="spinner-border spinner-border-sm text-primary" role="status"></div>
                                                <p className="small text-muted mt-2">Loading journal items...</p>
                                            </div>
                                        ) : journalDetails ? (
                                            <div className="table-responsive">
                                                <table className="table table-sm table-borderless align-middle mb-0">
                                                    <thead className="bg-light">
                                                        <tr className="small text-muted">
                                                            <th>Ledger</th>
                                                            <th className="text-end">Debit</th>
                                                            <th className="text-end">Credit</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        {journalDetails.items?.map((item, idx) => (
                                                            <tr key={idx} className="border-bottom-dashed">
                                                                <td>
                                                                    <div className="fw-medium small text-truncate" style={{maxWidth: '200px'}} title={item.ledger_name}>
                                                                        {item.ledger_name}
                                                                    </div>
                                                                </td>
                                                                <td className="text-end text-primary small">
                                                                    {item.dc === 'D' ? formatCurrency(item.amount) : '-'}
                                                                </td>
                                                                <td className="text-end text-success small">
                                                                    {item.dc === 'C' ? formatCurrency(item.amount) : '-'}
                                                                </td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                    <tfoot className="border-top">
                                                        <tr className="fw-bold small">
                                                            <td>Total</td>
                                                            <td className="text-end text-primary">
                                                                {formatCurrency(journalDetails.items?.reduce((sum, item) => item.dc === 'D' ? sum + item.amount : sum, 0) || 0)}
                                                            </td>
                                                            <td className="text-end text-success">
                                                                {formatCurrency(journalDetails.items?.reduce((sum, item) => item.dc === 'C' ? sum + item.amount : sum, 0) || 0)}
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                </table>
                                                <div className="mt-2 d-flex justify-content-between">
                                                    <small className="text-muted">Journal ID: <span className="text-primary fw-bold">#{selectedExpense.journal_id}</span></small>
                                                    <small className="text-muted">No: {journalDetails.number}</small>
                                                </div>
                                            </div>
                                        ) : (
                                            <div className="text-center py-3 text-danger small">
                                                <i className="mdi mdi-alert-circle-outline me-1"></i>
                                                Could not fetch journal details
                                            </div>
                                        )
                                    ) : (
                                        <div className="text-center py-3 text-warning bg-warning bg-opacity-10 rounded">
                                            <i className="mdi mdi-alert-outline me-1"></i>
                                            No Journal Entry linked to this expense
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Purchase Order Details */}
                            {selectedExpense.purchase_order && (
                                <div className="card border-0 shadow-sm mb-4">
                                    <div className="card-body">
                                        <h6 className="text-muted mb-3">
                                            <i className="mdi mdi-file-document-outline me-1"></i>
                                            Purchase Order
                                        </h6>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">PO Ref:</span>
                                            <span
                                                className="fw-medium text-primary text-truncate"
                                                style={{ maxWidth: '150px' }}
                                                title={selectedExpense.purchase_order.ref_no}
                                            >
                                                {selectedExpense.purchase_order.ref_no}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Date:</span>
                                            <span className="fw-medium">
                                                {moment(selectedExpense.purchase_order.date).format('DD MMM YYYY')}
                                            </span>
                                        </div>
                                        <div className="d-flex justify-content-between mb-2">
                                            <span className="small text-muted">Amount:</span>
                                            <span className="fw-medium">{formatCurrency(selectedExpense.purchase_order.amount)}</span>
                                        </div>
                                        {/* <div className="d-flex justify-content-between">
                                            <span className="small text-muted">Status:</span>
                                            <span className="badge bg-info">{selectedExpense.purchase_order.status}</span>
                                        </div> */}
                                    </div>
                                </div>
                            )}

                            {/* Payment History */}
                            <div className="card border-0 shadow-sm mb-4">
                                <div className="card-body">
                                    <h6 className="text-muted mb-3">
                                        <i className="mdi mdi-history me-1"></i>
                                        Payment History
                                    </h6>

                                    <div className="d-flex justify-content-between mb-3 bg-light p-2 rounded">
                                        <div>
                                            <small className="text-muted d-block">Paid Amount</small>
                                            <span className="fw-bold text-success">{formatCurrency(selectedExpense.paid_amount || 0)}</span>
                                        </div>
                                        <div className="text-end">
                                            <small className="text-muted d-block">Balance</small>
                                            <span className="fw-bold text-danger">{formatCurrency(selectedExpense.balance_amount || 0)}</span>
                                        </div>
                                    </div>

                                    {selectedExpense.transactions && selectedExpense.transactions.length > 0 ? (
                                        <div className="payment-history-list">
                                            {selectedExpense.transactions.map((tx, idx) => (
                                                <div key={idx} className="p-3 bg-light rounded mb-3 border">
                                                    <div className="d-flex justify-content-between align-items-center mb-2">
                                                        <span className="small fw-bold text-primary">Transaction</span>
                                                        <span className={`badge bg-opacity-10 ${tx.account_type?.toLowerCase().includes('bank') ? 'bg-white text-black' : 'bg-white text-success'}`}>
                                                            {tx.account_type?.toLowerCase().includes('bank') ? 'Bank' : 'Cash'}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between mb-1">
                                                        <span className="small text-muted">Date:</span>
                                                        <span className="small fw-medium">{moment(tx.transaction_date).format('DD MMM YYYY')}</span>
                                                    </div>

                                                    <div className="d-flex justify-content-between mb-1">
                                                        <span className="small text-muted">Account:</span>
                                                        <span className="small fw-medium text-truncate" style={{ maxWidth: '180px' }} title={tx.account_name}>
                                                            {tx.account_name}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between mb-1">
                                                        <span className="small text-muted">Ref No:</span>
                                                        <span className="small fw-medium text-truncate" style={{ maxWidth: '180px' }} title={tx.reference}>
                                                            {tx.reference}
                                                        </span>
                                                    </div>

                                                    <div className="d-flex justify-content-between pt-1 border-top mt-1">
                                                        <span className="small text-muted fw-bold">Paid amount:</span>
                                                        <span className="fw-bold text-success">{formatCurrency(tx.amount_paid)}</span>
                                                    </div>
                                                </div>
                                            ))}
                                        </div>
                                    ) : (
                                        <div className="text-center py-3 text-muted small">
                                            No payment transactions found
                                        </div>
                                    )}
                                </div>
                            </div>

                            {/* Additional Information */}
                            {(selectedExpense.notes || selectedExpense.attatchment || selectedExpense.attachment || selectedExpense.tax_invoice_file) && (
                                <div className="card border-0 shadow-sm">
                                    <div className="card-body">
                                        {(selectedExpense.attatchment || selectedExpense.attachment || selectedExpense.tax_invoice_file) && (
                                            <div className="mb-3">
                                                <h6 className="text-muted mb-2">
                                                    <i className="mdi mdi-attachment me-1"></i>
                                                    Voucher / Attachment
                                                </h6>
                                                <a 
                                                    href={`${backendUrl}/storage/${selectedExpense.attatchment || selectedExpense.attachment || selectedExpense.tax_invoice_file}`}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                    className="btn btn-sm btn-outline-primary"
                                                >
                                                    <i className="mdi mdi-download me-1"></i>
                                                    View Document
                                                </a>
                                            </div>
                                        )}
                                        {selectedExpense.notes && (
                                            <>
                                                <h6 className="text-muted mb-2">Additional Notes</h6>
                                                <p className="mb-0">{selectedExpense.notes}</p>
                                            </>
                                        )}
                                    </div>
                                </div>
                            )}
                        </div>
                    )}
                </Offcanvas.Body>
            </Offcanvas>



        </div>
    );
};

export default ExpenseReport;